import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  QueryList,
  ViewChildren,
  ElementRef,
  ViewEncapsulation,
  NgZone,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  AfterViewInit,
} from "@angular/core";
import { MatTab, MatTabGroup } from "@angular/material/tabs";
import { ActivatedRoute, Router } from "@angular/router";
import { OnboardingService } from "../../shared/service/onboarding.service";
import {
  FormControl,
  FormGroup,
  FormArray,
  FormBuilder,
  AbstractControl,
  Validators,
} from "@angular/forms";
import { OnboardEmergencyContactDetails } from "../../shared/models/OnboardEmergencyContactDetails";
import { MatDialog, MatTableDataSource, DateAdapter } from "@angular/material";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../shared/service/user.service";
import { AppConfig } from "../../app.config";
import { DatePipe, formatDate } from "@angular/common";
import { EmployeeService } from "../../shared/service/employee.service";
import { Awards } from "../../shared/models/Awards";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { PersonalDetailsComponent } from "../../onboarding/personal-details/personal-details.component";
import { EducationDetailsComponent } from "../../onboarding/education-details/education-details.component";
import { PreviousEmploymentComponent } from "../../onboarding/previous-employment/previous-employment.component";
import { ReferenceDetailsComponent } from "../../onboarding/reference-details/reference-details.component";
import { PassportvisaInformationComponent } from "../../onboarding/passportvisa-information/passportvisa-information.component";
import { FinanceDetailsComponent } from "../../onboarding/finance-details/finance-details.component";
import {
  BasicEmployeeDetails,
  EmpHistoryDetails,
  EmployeeAdditionalSkills,
  HistoryDetails,
} from "../../shared/models/basicemployeedetails.model";
import {
  HREmployeeDetails,
  Skillset,
} from "../../shared/models/hremployeecommunicationdetails.model";
import { isNullOrUndefined, debug } from "util";
import { HrEmpEducationDetails } from "../../shared/models/hrEmpEducationDtls";
import { HrEmpProfessionalReferenceDetails } from "../../shared/models/hrEmpReferenceDtls";
import { HrEmployeePassportVisaInfo } from "../../shared/models/hrEmpPassportVisaDtls";
import { HrEmployeeFinanceDetails } from "../../shared/models/hrEmpFinanceDtls";
import { BasicEmpDetailsComponent } from "../../onboarding/basic-emp-details/basic-emp-details.component";
import { HrEmpEducationInfo } from "../../shared/models/HrEmpEducationInfo";
import { hrEmpPersonalDetails } from "../../shared/models/hrEmpPersonalDetails";
import { HrAwardsComponent } from "../hr-awards/hr-awards.component";
import { HrHistoryComponent } from "../hr-history/hr-history.component";
import { HrHiringDetailsComponent } from "../hr-hiring-details/hr-hiring-details.component";
import { HrBasicDetailsComponent } from "../hr-basic-details/hr-basic-details.component";
import { HrEmpCommunicationDetailsComponent } from "../hr-emp-communication-details/hr-emp-communication-details.component";
import { EmployeeModel } from "../../shared/models/employee.model";
import { MyProfileSummaryComponent } from "../my-profile-summary/my-profile-summary.component";
import { OnboardVrifications } from "../../shared/models/OnboardVrifications";
import { ProfileVerificationStatus } from "../../shared/models/ProfileVerificationStatus";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { EmpPreviousEmploymentDetails } from "../../shared/models/hrEmpPrevEmpDtls";
import { SeniorManagersHistoryDetails } from "../../shared/models/SeniorManagersHistoryDetails";
import { Offboarding } from "../../shared/models/Offboarding";
import { HrEmpInitiateExitComponent } from "../hr-emp-initiate-exit/hr-emp-initiate-exit.component";
import { ExitInterviews } from "../../shared/models/ExitInterviews";
import { BehaviorSubject } from "rxjs";
import { SkillSetComponent } from "../skill-set/skill-set.component";
import * as CryptoJS from "crypto-js";
import { OnboardOTP } from "../../shared/models/OnboardOTP";
import * as moment from "moment-timezone";
import { LocalStorageService } from "../../shared/service/local-storage.service";
import { MatTabHeader } from "@angular/material/typings/esm5/tabs";

declare var $: any;
type groupIdResult = (result: boolean) => void;
@Component({
  selector: "app-hr-employee-details",
  templateUrl: "./hr-employee-details.component.html",
  styleUrls: ["./hr-employee-details.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush
  // encapsulation: ViewEncapsulation.None
})
export class HrEmployeeDetailsComponent implements OnInit, AfterViewInit{
  @ViewChild(HrBasicDetailsComponent, { static: false })
  hrBasicDetailsComponent: HrBasicDetailsComponent;
  @ViewChild(HrEmpCommunicationDetailsComponent, { static: false })
  hrEmpCommunicationDetailsComponent: HrEmpCommunicationDetailsComponent;
  @ViewChild(SkillSetComponent, { static: false })
  skillsetComponent: SkillSetComponent;
  @ViewChild(HrEmpInitiateExitComponent, { static: false })
  hrEmpInitiateExitComponent: HrEmpInitiateExitComponent;
  @ViewChild(BasicEmpDetailsComponent, { static: false })
  basicEmpDetComponent: BasicEmpDetailsComponent;
  @ViewChild(PersonalDetailsComponent, { static: false })
  personalDetailsComponent: PersonalDetailsComponent;
  @ViewChild(EducationDetailsComponent, { static: false })
  educationDetailsComponent: EducationDetailsComponent;
  @ViewChild(PreviousEmploymentComponent, { static: false })
  previousEmploymentComponent: PreviousEmploymentComponent;
  @ViewChild(ReferenceDetailsComponent, { static: false })
  referenceDetailsComponent: ReferenceDetailsComponent;
  @ViewChild(PassportvisaInformationComponent, { static: false })
  passportvisaInformationComponent: PassportvisaInformationComponent;
  @ViewChild(FinanceDetailsComponent, { static: false })
  financeDetailsComponent: FinanceDetailsComponent;
  @ViewChild(HrAwardsComponent, { static: false })
  hrAwardsComponent: HrAwardsComponent;
  @ViewChild(MatTabGroup, { static: false }) tabGroup: MatTabGroup;
  @ViewChild(HrHistoryComponent, { static: false })
  hrHistoryComponent: HrHistoryComponent;
  @ViewChild(MyProfileSummaryComponent, { static: false })
  hrmyprofilesummary: MyProfileSummaryComponent;
  @ViewChild(HrHiringDetailsComponent, { static: false })
  hrHiringDetailsComponent: HrHiringDetailsComponent;
  @ViewChild(HrEmpInitiateExitComponent, { static: false })
  HrEmpInitiateExitComponent: HrEmpInitiateExitComponent;

  MAX_SIZE: number = 1048576;
  slug: any;
  error: string;
  date: Date;
  MaritalStatus: any;
  isLoader: boolean = true;
  NPS: any;
  selectedIndex = 0;
  rows: FormArray = this.fb.array([]);
  prevEmp: FormArray = this.fb.array([]);
  prevEmpDet: FormArray = this.fb.array([]);
  PriorExperienceYears: number;
  PriorExperienceMonths: number;
  empPreviousEmploymentDetails: EmpPreviousEmploymentDetails;
  passportArray: FormArray = this.fb.array([]);
  visaArray: FormArray = this.fb.array([]);
  referenceDetails: HrEmpProfessionalReferenceDetails[] = [];
  emerContactDetails: OnboardEmergencyContactDetails[] = [];
  result: any;
  HrEmpDtls: BasicEmployeeDetails;
  HrEmp: HistoryDetails;
  seniorManager: SeniorManagersHistoryDetails;
  employeeDetails: HREmployeeDetails;
  skillsetDetails: any;
  OffboardingDetails: Offboarding;
  ExitDetails: ExitInterviews;
  personalDetails: hrEmpPersonalDetails;
  educationDetails: HrEmpEducationDetails[] = [];
  passportVisaDetails: HrEmployeePassportVisaInfo;
  FinanceDetails: HrEmployeeFinanceDetails;
  datePipe: DatePipe;
  Status: number;
  duplicatemp: any;
  emailemp: any;
  Check: number = 1;
  empList: any[];
  emailverifyform: FormGroup;
  submitted: boolean;
  exception: boolean;
  award: Awards;
  EmpCode: number;
  LoginDept: any;
  LoginEmpCode: any;
  additionalQualifications: any[];
  educationInfo: HrEmpEducationInfo;
  Children: FormArray = this.fb.array([]);
  awardDetail: any;
  @Input() empCode: number;
  awardDetails: Awards[] = [];
  disableTabs: boolean = false;
  parentComponentName: string;
  permission: any;
  editEnable: boolean = true;
  isProfile: boolean = false;
  VerificationDetails: OnboardVrifications[] = [];
  EmpId: number;
  tabslist: any[];
  profileverificationDetails: ProfileVerificationStatus[];
  summaryStatus: ProfileVerificationStatus;
  Verify: ProfileVerificationStatus = new ProfileVerificationStatus();
  profileStatus: any[] = [];
  personalbool: boolean;
  FinanceDetCB: boolean = false;
  basicbool: boolean = false;
  previousbool: boolean;
  passportbool: boolean;
  educationbool: boolean;
  sendMail: ProfileVerificationStatus[] = [];
  mailArray: ProfileVerificationStatus[] = [];
  jsonlist: string;
  checkedVerified: boolean = false;
  showTab: boolean = false;
  approveCheck: boolean = false;
  fullName: string;
  disableSave: boolean = false;
  disableCheckbox: boolean = false;
  loader: boolean;
  email: any;
  checkProfileSubmitBasic: boolean;
  checkProfileSubmitPersonal: boolean;
  messageHideVariable: boolean = false;
  messageHideVariableBasic: boolean = false;
  indexOld = 0;
  index = 0;
  isProgrammaticChange: boolean;
  isAccordionVisible: boolean = false;
  hrHiringDetails: any;
  isPersonalDetailsTabRefresh: boolean = false;
  isBasicDetailsTabRefresh: boolean = false;
  isEduDetailsTabRefresh: boolean = false;
  isPrevEmpDetailsTabRefresh: boolean = false;
  isPassportDetailsTabRefresh: boolean = false;
  isFinanceDetailsTabRefresh: boolean = false;
  isAwardsDetailsTabRefresh: boolean = false;
  isHiringDetailsTabRefresh: boolean = false;
  isHistoryDetailsTabRefresh: boolean = false;
  isCancelPreviousState: boolean = true;
  @ViewChildren(MatTab) tabs: QueryList<MatTab>;
  isCheckboxChecked: boolean = false;
  isComponentActive = true;
  employeeId: number | null;
  divRemoved = false;
  EmployeeList: BasicEmployeeDetails[];
  groupId: string;
  dob: any;
  EmpGroupIDDetails: BasicEmployeeDetails;
  secondaryEmail: any;
  HREmp: BasicEmployeeDetails;
  ResponseList: any;
  isFeedbackRequired: boolean = false;
  isFeedbackSubmitted: boolean = false;
  isNewRecord: boolean = false;
  isAccordion: boolean = false;
  private employeelistSubject = new BehaviorSubject<BasicEmployeeDetails[]>([]);

  OtpText: boolean;
  OTPCode: any;
  isAllowAccess: boolean = false;
  errorOtp = "";
  privateKeyBase64: string = "b14ca5898a4e4133bbce2ea2315a1916";
  MobileNo: any;
  isEdit: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private config: AppConfig,
    private _service: OnboardingService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private userService: UserService,
    private emp_Svc: EmployeeService,
    private changeCom_svc: ComponentIdentificationService,
    public router: Router,
    private file_Svc: FileUploadService,
    private elementRef: ElementRef,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private _onboardingService: OnboardingService,
    private _localStorage: LocalStorageService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.groupId = params["groupId"];
      this.dob = params["dob"];
      this.secondaryEmail = params["secondaryEmail"];
    });
    //get the employee code from url
    this.route.params.subscribe((params) => {
      if (params["empCode"]) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.empCode = params["empCode"];
      this.getDetailsByEmpCode(this.empCode);
      this.initializeParamChange();
    });
    //this.getAllEmployees();
  }

  getDetailsByEmpCode(empCode) {
    if (empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe(
        (data: any) => {
          this.HREmp = data;
        },
        (error) => (this.error = error)
      );
    }
  }

  initializeParamChange() {
    this.permission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
    if (this.router.url.startsWith("/myprofile/")) {
      this.permission = this.userService.userInfo.permissions.find(
        (i) => i.Menu === "MyProfile"
      );
    }
    var offboardingPermission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Offboarding"
    );
    //if (offboardingPermission != null && offboardingPermission.HasFullAccess) {
    //  this.router.navigate(['/Offboardinglist/tabIndex/0'])
    //}
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    this.EmpId = this.LoginEmpCode;
    this.LoginDept = this.userService.getDepartment();
    if (!isNullOrUndefined(this.empCode)) {
      this.editEnable = this.permission.EditingPermission;
      if (this.router.url.startsWith("/myprofile/")) {
        if (this.empCode === this.LoginEmpCode) {
          this.isProfile = true;
          //if(this.LoginDept == 'HR' && this.permission)
        } else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    } else {
      //for creation of new employee only first tab will be active remaining must be disabled
      this.isNewRecord = true;
      this.disableTabs = true;
    }
  }

  ngOnInit() {
   
    //get the parent component name from where this component is called
    this.changeCom_svc.componentName.subscribe(
      (response) => (this.parentComponentName = response)
    );
    //Assign the parent component name to recognize the parent in child component
    this.changeCom_svc.changeComponentName("app-hr-employee-details");
    this.fullName = this.userService.getFullName();
    this.email = this.userService.getEmail();
    this.emailverifyform = this.fb.group({
      emailId: ["", [Validators.required, emailDomain]],
    });

    this.OffboardingDetails = new Offboarding();
    this.employeeDetails = new HREmployeeDetails();
    this.EmpGroupIDDetails = new BasicEmployeeDetails();
    //this.HrEmpDtls.seniorManagersHistoryDetails = new HrHistoryComponent()
    this.personalDetails = new hrEmpPersonalDetails();
    this.passportVisaDetails = new HrEmployeePassportVisaInfo();
    this.FinanceDetails = new HrEmployeeFinanceDetails();
    this.educationInfo = new HrEmpEducationInfo();
    this.HrEmp = new HistoryDetails();
    this.selectedIndex = 0;
   // this.getEmployeeList();
    
    this.award = new Awards();
      if (this.router.url.startsWith("/myprofile/")) {
        this.LoginEmpCode = this.userService.getEmpCode().toString();
        this.LoginDept = this.userService.getDepartment();
        if (this.empCode === this.LoginEmpCode) {
          this.showTab = true;
          //this.GetProfileVerificationStatus();
        }
      }
      this.emp_Svc
        .getOffboardingDetails(this.LoginEmpCode)
        .subscribe((data: any) => {
          this.OffboardingDetails = data;
          this.checkBoxState();
        });
      this.gettabslist();
      this.getExitInterviewResponses();
    window.addEventListener("scroll", this.scroll, true); //third parameter
    //setTimeout(() => {
    //  this.isLoader = false;
    //}, 1500);
    this.getBasicEmployeeByCodeforNumber();
  }

  ngAfterViewInit() {
    if (this.isAllowAccess && this.isProfile)
      this.registerTabClick();
  }

  registerTabClick(): void {
    console.log(!this.isProgrammaticChange)
    const handleTabClick = (this.tabGroup as any)._handleClick;
    (this.tabGroup as any)._handleClick = (tab: any, header: any, index: number) => {
      if (!this.isProgrammaticChange) {
        let unsavedChanges = false;

        if (this.indexOld != null && index !== this.indexOld) {
          switch (this.indexOld) {
            case 0:
              unsavedChanges = this.hrBasicDetailsComponent.getObjectState() ||
                this.hrEmpCommunicationDetailsComponent.getObjectState();
              break;
            case 1:
              unsavedChanges = this.personalDetailsComponent.getObjectState();
              break;
            case 2:
              unsavedChanges = this.educationDetailsComponent.getObjectState();
              break;
            case 3:
              unsavedChanges = this.previousEmploymentComponent.getObjectState();
              break;
            case 4:
              unsavedChanges = this.passportvisaInformationComponent.getObjectState();
              break;
            case 5:
              unsavedChanges = this.financeDetailsComponent.getObjectState();
              break;
          }
        }
        
        if (this.indexOld != null && index !== this.indexOld && unsavedChanges) {
          const confirmSwitch = confirm(
            `You have unsaved changes. Would you like to discard them and move to the "${this.tabs.toArray()[index].textLabel}" tab?`
          );

          if (!confirmSwitch) {
            this.tabGroup.selectedIndex = this.indexOld; // Revert tab
            return;
          }
        }

        handleTabClick.call(this.tabGroup, tab, header, index);
        this.index = index;
        this.indexOld = index;
        this.selectedIndex = index;
        this.onManualTabClickRefresh(index)

        if (index === 7 && this.router.url.startsWith("/hremployeedetails/")) {
          this.GetEmployeeAwardDetails();
        }
        if (this.router.url.startsWith("/myprofile/")) {
          // this.GetProfileVerificationStatus();
        }
      } else if (this.isProgrammaticChange) {
        handleTabClick.call(this.tabGroup, tab, header, index);
        this.index = index;
        this.indexOld = index;
        this.selectedIndex = index;
        this.isProgrammaticChange = false;
      }
    };
  }


  ngOnDestroy() {
    //this.isComponentActive = false;
    window.removeEventListener("scroll", this.scroll, true);
    //clearTimeout(this.checkBoxState);
    // this.elementRef.nativeElement.remove();
  }

  slugify(input) {
    return input.replace(/[@.]/g, "-");
  }

  activate() {
    const slugValue = this.slugify(this.HREmp.SecondaryEmail);
    this._onboardingService
      .validateOTP({ empCode: this.empCode, OTPCode: this.OTPCode })
      .subscribe(
        (data: any) => {
          this.errorOtp = "";
          if (data.Success == true) {
            this.exception = false;
            this.OtpText = false;
            this.isAllowAccess = true;
          } else {
            this.exception = true;
            this.errorOtp = data.ErrorMessage;
            this.toastr.warning("Invalid OTP");
          }
          this.cdr.detectChanges();
          if (this.isAllowAccess)
            this.registerTabClick();
        },
        (error) => (this.error = error)
      );
  }

  getBasicEmployeeByCodeforNumber() {
    if (this.empCode != null && this.HREmp != null) {
      this.MobileNo = this.HREmp.MobileNo;
      this.cdr.detectChanges();
      //this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
      //  this.MobileNo = data.MobileNo;
      //});
    }
    this.cdr.detectChanges();
    this.isLoader = false;
    return this.MobileNo;
  }

  generateOTP() {
    this.errorOtp = "Wait for few seconds....";
    if (this.HREmp) {
      // const slugValue = this.slugify(this.HREmp.SecondaryEmail);
      this._onboardingService.generateOTP(this.empCode, "MyProfile").subscribe(
        (data: any) => {
          this.errorOtp = "";
          if (data.Success == true) {
            this.exception = false;
            this.OtpText = true;
            const num = this.getBasicEmployeeByCodeforNumber();
            this.toastr.success(
              "OTP has been sent to mobile# XXXXXX" + num.slice(-4)
            );
          } else {
            this.exception = true;
            this.errorOtp = data.ErrorMessage;
            this.toastr.warning(this.error);
          }
        },
        (error) => (this.error = error)
      );
    }
  }

  ngOnChanges() {
    this.updateStickyPosition();
  }
  //scroll = (event): void => {
  //  var window_top = $(window).scrollTop();
  //  var top = $("#stick-here").offset().top;
  //  if (
  //    window_top > top
  //  ) {
  //    $("#stickThis").addClass("stick");
  //    $("#stick-here").height($("#stickThis").outerHeight());
  //    } else {
  //    this.removeStickyDiv();
  //  }
  //};
  scroll = (event): void => {
    var window_top = $(window).scrollTop();
    var top = $("#stick-here").offset().top;
    const stickThisElement = document.getElementById("stickThis");
    if (window_top > top) {
      if (this.isProfile && this.indexOld === 0 && this.isCheckboxChecked) {
      } else {
        stickThisElement.classList.add("stick");
      }
    } else {
      this.removeStickyDiv();
    }
  };

  async getEmployeeList() {
    try {
      const data: any[] = await this.emp_Svc.getAllActiveEmployees().toPromise();

      const tempList = [];
      this.empList = data;
      this.empList.forEach((el) => {
        let item = el;
        item.recDisplayName = el.FirstName + ' - ' + el.EmpCode;
        item.recEmpCode = el.EmpCode;
        tempList.push(item);
      });
      this.empList = tempList;
    } catch (error) {
      this.error = error;
    }
  }

  //To make the mat-tab move to next tab
  changeTab() {
    const nextIndex = this.selectedIndex + 1;

    if (nextIndex < 0) return;

    const tabGroupAny = this.tabGroup as any;
    const tabHeader = tabGroupAny._tabHeader;
    const tab = tabGroupAny._tabs._results[nextIndex];

    if (tab && tabHeader) {
      this.isProgrammaticChange = true;
      tabGroupAny._handleClick(tab, tabHeader, nextIndex);
    }

    this.removeStickyDiv();
  }

  gettabslist() {
    this.emp_Svc.getTabs().subscribe(
      (data: any[]) => {
        this.tabslist = data;
      },
      (error) => (this.error = error)
    );
  }
  hideTabButKeepContent(param) {
    if (this.router.url.startsWith("/myprofile/")) {
      //this.showTab = true;
      this.showTab = false;
    }
    return this.showTab;
  }

  cancelConfirmation(tab) {
    if (this.indexOld != null && tab.selectedIndex != this.indexOld) {
      {
        switch (tab.selectedIndex) {
          case 0:
            this.toggleBasicDetailsComponent();
            break;
          case 1:
            this.togglePersonalDetailsComponent();
            break;
          case 2:
            this.toggleHiringDetailsComponent();
            break;
          case 3:
            this.toggleEducationDetailsComponent();
            break;
          case 4:
            this.togglePreviousDetailsComponent();
            break;
          case 5:
            this.togglePassportDetailsComponent();
            break;
          case 6:
            this.toggleFinancialDetailsComponent();
            break;
          case 7:
            this.toggleAwardsDetailsComponent();
            break;
          case 8:
            this.toggleHistoryDetailsComponent();
            break;
        }
      }
    }
  }

  //tabClick(tab: any, index: number) {
  //  var confirmation = false;
  //  this.isCancelPreviousState = true;
  //  if (!this.isProgrammaticChange) {
  //    var showConfirmation = false;
  //    if (this.indexOld != null && tab.selectedIndex != this.indexOld) {
  //      {
  //        switch (this.indexOld) {
  //          case 0:
  //            var basic = this.hrBasicDetailsComponent.getObjectState();
  //            var com =
  //              this.hrEmpCommunicationDetailsComponent.getObjectState();
  //            showConfirmation = basic || com;
  //            break;
  //          case 1:
  //            showConfirmation = this.personalDetailsComponent.getObjectState();
  //            break;
  //          case 2:
  //            showConfirmation = this.hrHiringDetailsComponent.getObjectState();
  //            break;
  //          case 3:
  //            showConfirmation = this.educationDetailsComponent.getObjectState();
  //            break;
  //          case 4:
  //            showConfirmation = this.previousEmploymentComponent.getObjectState();
  //            break;
  //          case 5:
  //            showConfirmation = this.passportvisaInformationComponent.getObjectState();
  //            break;
  //          case 6:
  //            showConfirmation = this.financeDetailsComponent.getObjectState();
  //            break;
  //          case 7:
  //            showConfirmation = this.hrAwardsComponent.getObjectState();
  //            break;
  //          case 8:
  //            showConfirmation =
  //              this.hrHistoryComponent &&
  //              this.hrHistoryComponent.getObjectState();
  //            this.toggleBasicDetailsComponent();
  //            this.togglePersonalDetailsComponent();
  //            break;
  //        }
  //      }
  //    }
  //    var confirmation = false;
  //    if (
  //      this.indexOld != null &&
  //      tab.selectedIndex != this.indexOld &&
  //      showConfirmation)
  //    {
  //      if (confirm(
  //          "You have unsaved changes. Would you like to discard them and move to the " +
  //            this.tabs.toArray()[tab.selectedIndex].textLabel +
  //        " tab?."))
  //      {
  //        confirmation = false;
  //        this.cancelConfirmation(tab);
  //      }
  //      else {
  //        this.isCancelPreviousState = false;
  //        confirmation = true;
  //      }
  //      if (tab.selectedIndex != this.indexOld && !confirmation) {
  //        this.index = index;
  //        this.indexOld = tab.selectedIndex;
  //        if (
  //          tab.selectedIndex == 7 &&
  //          this.router.url.startsWith("/hremployeedetails/")
  //        ) {
  //          this.GetEmployeeAwardDetails();
  //        }
  //        if (this.router.url.startsWith("/myprofile/")) {
  //          this.GetProfileVerificationStatus();
  //        }
  //        this.onManualTabClickRefresh(tab.selectedIndex);
  //      } else {
  //        this.selected.setValue(this.indexOld);
  //      }
  //    } else if (!showConfirmation) {
  //      if (tab.selectedIndex != this.indexOld) {
  //        this.index = index;
  //        this.indexOld = tab.selectedIndex;
  //        if (
  //          tab.selectedIndex == 7 &&
  //          this.router.url.startsWith("/hremployeedetails/")
  //        ) {
  //          this.GetEmployeeAwardDetails();
  //        }
  //        if (this.router.url.startsWith("/myprofile/")) {
  //          this.GetProfileVerificationStatus();
  //        }
  //        this.onManualTabClickRefresh(tab.selectedIndex);
  //      }
  //    }
  //  } else {
  //    this.isProgrammaticChange = false;
  //  }
  //  //  if (tab.selectedIndex != this.indexOld) {
  //  //    const dialogRef = this.dialog.open(....)
  //  //    const res = dialogRef.afterClosed().subscribe(result => {
  //  //      if (result === 1) {
  //  //        this.index = index;
  //  //        this.indexOld = index;
  //  //      } else {
  //  //        tab.selectedIndex = this.indexOld;
  //  //      }
  //  //    });
  //  //  }
  //  //  else {
  //  //    this.index = index;
  //  //  }
  //  //}

  //  //if (event.index == 7) {
  //  // this.router.navigateByUrl(`/employeehistory/${this.empCode}`);
  //  //}
  //  setTimeout(() => {
  //    this.isLoader = false;
  //  }, 1500);
  //}

  tabClick(tab: any, index: number) {
    if (!this.isProgrammaticChange) {
      let unsavedChanges = false;
      if (this.indexOld != null && tab.selectedIndex !== this.indexOld) {
        switch (this.indexOld) {
          case 0:
            unsavedChanges = this.hrBasicDetailsComponent.getObjectState() ||
              this.hrEmpCommunicationDetailsComponent.getObjectState();
            break;
          case 1:
            unsavedChanges = this.personalDetailsComponent.getObjectState();
            break;
          case 2:
            unsavedChanges = this.educationDetailsComponent.getObjectState();
            break;
          case 3:
            unsavedChanges = this.previousEmploymentComponent.getObjectState();
            break;
          case 4:
            unsavedChanges = this.passportvisaInformationComponent.getObjectState();
            break;
          case 5:
            unsavedChanges = this.financeDetailsComponent.getObjectState();
            break;
        }
      }
      if (this.indexOld != null && tab.selectedIndex !== this.indexOld && unsavedChanges) {
        if (confirm(
          "You have unsaved changes. Would you like to discard them and move to the " +
          this.tabs.toArray()[tab.selectedIndex].textLabel +
          " tab?")) {
          this.index = index;
          this.indexOld = index;
         // this.onManualTabClickRefresh(tab.selectedIndex)
        }
        else {
          tab.selectedIndex = this.indexOld;
        }
      }
      else if (tab.selectedIndex !== this.indexOld && !unsavedChanges) {
        this.index = index;
        this.indexOld = tab.selectedIndex;
        //this.onManualTabClickRefresh(tab.selectedIndex)
      }

      if (tab.selectedIndex === 7 && this.router.url.startsWith("/hremployeedetails/")) {
        this.GetEmployeeAwardDetails();
      }
      if (this.router.url.startsWith("/myprofile/")) {
        //this.GetProfileVerificationStatus();
      }
    } else {
      this.isProgrammaticChange = false;
    }
    //setTimeout(() => {
    //  this.isLoader = false;
    //}, 1500);
  }


  onManualTabClickRefresh(tabIdx) {
    //this.isLoader = true;
    switch (tabIdx) {
      case 0:
        this.toggleBasicDetailsComponent();
        break;
      case 1:
        this.togglePersonalDetailsComponent();
        break;
      case 2:
        this.toggleEducationDetailsComponent();
        break;
      case 3:
        this.togglePreviousDetailsComponent();
        break;
      case 4:
        this.togglePassportDetailsComponent();
        break;
      case 5:
        this.toggleFinancialDetailsComponent();
        break;
    }
    //setTimeout(() => {
    //  this.isLoader = false;
    //}, 2000);
  }

  //To make the mat-tab move to previous tab
  BackTab() {
    const previousIndex = this.selectedIndex - 1;
    console.log(previousIndex)
    if (previousIndex < 0) return;
    const tabGroupAny = this.tabGroup as any;
    const tabHeader = tabGroupAny._tabHeader;
    const tab = tabGroupAny._tabs._results[previousIndex];
    if (tab && tabHeader) {
      this.isProgrammaticChange = false;
      tabGroupAny._handleClick(tab, tabHeader, previousIndex);
    }
    this.removeStickyDiv();
  }
  removeStickyDiv() {
    $("#stickThis").removeClass("stick");
    $("#stick-here").height(0);
  }

  //To clear the form data in each tab by switch condition
  ResetData(value) {
    switch (value) {
      case "basichrdetails":
        this.hrBasicDetailsComponent.HrDetailsForm.reset();
        this.hrBasicDetailsComponent.EmpDetform.reset();
        this.hrBasicDetailsComponent.getCommunicationData();
        this.hrBasicDetailsComponent.getBasicEmployeeByCode();
        this.hrEmpCommunicationDetailsComponent.EmpAddform.reset();
        this.hrEmpCommunicationDetailsComponent.getCommunicationData();
        this.skillsetComponent.Skillsetform.reset();
        this.skillsetComponent.getSkillsetData();
        break;
      case "personaldetails":
        this.personalDetailsComponent.PersonalDetform.reset();
        this.Children.clear();
        this.personalDetailsComponent.GetEmployeePersonalDetailsbyHR();
        break;
      case "educationdetails":
        this.educationDetailsComponent.EducationDetailForm.reset();
        this.educationDetailsComponent.reset();
        this.educationDetailsComponent.getHREmpData();
        break;
      case "prevemploymentdetails":
        this.previousEmploymentComponent.prevEmp = this.fb.array([]);
        this.previousEmploymentComponent.PrevEmploymentDetForm.reset();
        this.previousEmploymentComponent.reset();
        this.previousEmploymentComponent.GetHREmpPrevEmploymentDetails();
        break;
      case "referencedetails":
        this.previousEmploymentComponent.GetHREmpReferences();
        break;
      case "passportvisadetails":
        this.passportvisaInformationComponent.passportArray = this.fb.array([]);
        this.passportvisaInformationComponent.visaArray = this.fb.array([]);
        this.passportvisaInformationComponent.GetHREmpPassportVisaInfo();
        break;
      case "financedetails":
        this.financeDetailsComponent.FinanceForm.reset();
        this.financeDetailsComponent.GetHrEmpolyeeFinanceDetails();
        break;
      case "awardsdetails":
        this.hrAwardsComponent.AwardForm.reset();
        break;
      case "historydetails":
        this.hrHistoryComponent.EmpDetform.reset();
        this.hrHistoryComponent.getEmpHistory();
        //this.hrHistoryComponent.GetHistory();
        break;
      case "hiringdetails":
        this.hrHiringDetailsComponent.hrdetailsform.reset();
        this.hrHiringDetailsComponent.Reset();
        this.hrHiringDetailsComponent.getData();
        break;
    }
  }

  //Read the output values from child components
  getHrEmpDtlsOutput(val) {
    this.HrEmpDtls = val;
  }
  getHistoryOutput(val) {
    this.HrEmp = val;
  }
  getEmployeeDtlsOutput(val) {
    this.employeeDetails = val;
  }
  getEmployeeSkillsetDtlsOutput(val) {
    this.skillsetDetails = val;
  }
  getOffboardingDtlsOutput(val) {
    this.OffboardingDetails = val;
  }
  getEmpExitOutput(val) {
    this.ExitDetails = val;
  }
  getEducationDtlsOutput(val) {
    this.rows = val;
  }
  getPersonalDtlsOutput(val) {
    this.personalDetails = val;
  }
  getPrevEmploymentDtlsOutput(val) {
    this.prevEmp = val;
  }
  getReferenceDtlsOutput(val) {
    this.referenceDetails = val;
  }
  getPassportVisaDtlsOutput(val) {
    this.passportArray = val;
  }
  getVisaDtlsOutput(val) {
    this.visaArray = val;
  }
  getFinanceDtlsOutput(val) {
    this.FinanceDetails = val;
  }
  getChildrenArrayOutput(val) {
    this.Children = val;
  }
  getAdditionalQualificationsOutput(val) {
    this.additionalQualifications = val;
  }
  getAwardsDtlsOutput(val) {
    this.award = val;
  }
  getHrHiringDetailsDtlsOutput(val) {
    this.hrHiringDetails = val;
  }

  toggleAccordion(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    this.isAccordionVisible = checkbox.checked;

    //if (checkbox.checked && this.OffboardingDetails && this.OffboardingDetails.finalStatus === ' Saved') {
    //  this.deleteEmp(event);
    //}
  }

  onDeleteEmp(event: Event) {
    if (
      this.isAccordionVisible &&
      this.OffboardingDetails &&
      this.OffboardingDetails.finalStatus === "Saved"
    ) {
      this.deleteEmp(event);
    }
  }

  updateStickyPosition() {
    const stickThisElement = document.getElementById("stickThis");
    if (this.isProfile && this.isCheckboxChecked) {
      stickThisElement.classList.remove("stick");
      $("#stickThis").removeClass("stick");
      $("#stick-here").height(0);
    } else {
      stickThisElement.classList.add("stick");
    }
  }
  onCheckboxChange() {
    this.updateStickyPosition();
  }

  setProfile(isProfile: boolean) {
    this.isProfile = isProfile;
    this.updateStickyPosition();
  }

  deleteEmp(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    //this.isAccordionVisible = checkbox.checked;

    this.loader = true;
    var msg = `Are you sure to unsave the resignation?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.loader = true;
          window.scrollTo(0, 0);
          this.emp_Svc
            .getOffboardingDetails(this.LoginEmpCode)
            .subscribe((data: any) => {
              this.OffboardingDetails = data;
              const empId = data.ID;

              this.emp_Svc.DeleteOffboardingEmployee(empId).subscribe(
                (data: Offboarding) => {
                  const message = "Resignation unsaved Successfully";
                  this.toastr.success(message);
                  //this.isCheckboxChecked = false;
                  checkbox.checked = false;
                  this.loader = false;
                },
                (error) => (this.error = error)
              );
              setTimeout(() => {
                this.loader = false;
              }, 1000);
            });
        } else {
          this.loader = false;
          this.checkBoxState();
          setTimeout(() => {
            this.loader = false;
          }, 1000);
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }

  checkBoxState() {
    if (
      this.isCheckboxChecked ||
      (this.OffboardingDetails != null &&
        (this.OffboardingDetails.finalStatus === "Saved" ||
          this.OffboardingDetails.finalStatus === "Submitted" ||
          this.OffboardingDetails.finalStatus === "Approved" ||
          this.OffboardingDetails.finalStatus === "Rejected"))
    ) {
      this.isAccordionVisible = true;
      this.isCheckboxChecked = true;
    } else if (
      this.OffboardingDetails != null &&
      this.OffboardingDetails.finalStatus === "Confirmed"
    ) {
      this.isAccordionVisible = true;
      this.isCheckboxChecked = true;
    } else {
      this.isAccordionVisible = false;
      this.isCheckboxChecked = false;
    }
    this.cdr.detectChanges();
  }

  toggleRevoke() {
    // return this.OffboardingDetails != null && this.OffboardingDetails.finalStatus && this.OffboardingDetails.finalStatus == 'Submitted'
    return (
      this.OffboardingDetails != null &&
      (this.OffboardingDetails.finalStatus === "Submitted" ||
        this.OffboardingDetails.finalStatus === "Approved" ||
        this.OffboardingDetails.finalStatus === "Rejected" ||
        this.OffboardingDetails.finalStatus == "Confirmed")
    );
  }

  async getOffboardingdetailsbyCode() {
    try {
      this.OffboardingDetails = await this.emp_Svc
        .getOffboardingDetails(this.LoginEmpCode)
        .toPromise();
    } catch (error) {
      console.error("Error fetching offboarding details:", error);
    }
  }

  async revokeResignation() {
    this.loader = true;
    await this.getOffboardingdetailsbyCode();
    var msg = `Are you sure to revoke the resignation?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          window.scrollTo(0, 0);
          this.OffboardingDetails.finalStatus = "Revoked";
          this.OffboardingDetails.Status = null;
          this.emp_Svc
            .SaveOffboardingDetails(this.OffboardingDetails)
            .subscribe(
              (data: Offboarding) => {
                const message = "Resignation Revoked Successfully";
                this.toastr.success(message);
                // this.HrEmpInitiateExitComponent.enableFormFields();
                this.isCheckboxChecked = false;
                //this.loader = false;
                this.hrEmpInitiateExitComponent.getOffboardingdetailsbyCode();
                setTimeout(() => {
                  this.loader = false;
                }, 1000);
              },
              (error) => {
                this.error = error;
                setTimeout(() => {
                  this.loader = false;
                }, 1000);
              }
            );
        } else {
          this.loader = false;
          this.hrEmpInitiateExitComponent.getOffboardingdetailsbyCode();
          setTimeout(() => {
            this.loader = false;
          }, 1000);
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }

  toggleBasicDetailsComponent() {
    this.isBasicDetailsTabRefresh = !this.isBasicDetailsTabRefresh;
  }

  togglePersonalDetailsComponent() {
    this.isPersonalDetailsTabRefresh = !this.isPersonalDetailsTabRefresh;
  }

  toggleEducationDetailsComponent() {
    this.isEduDetailsTabRefresh = !this.isEduDetailsTabRefresh;
  }

  togglePreviousDetailsComponent() {
    this.isPrevEmpDetailsTabRefresh = !this.isPrevEmpDetailsTabRefresh;
  }

  togglePassportDetailsComponent() {
    this.isPassportDetailsTabRefresh = !this.isPassportDetailsTabRefresh;
  }

  toggleFinancialDetailsComponent() {
    this.isFinanceDetailsTabRefresh = !this.isFinanceDetailsTabRefresh;
  }

  toggleAwardsDetailsComponent() {
    this.isAwardsDetailsTabRefresh = !this.isAwardsDetailsTabRefresh;
  }

  toggleHiringDetailsComponent() {
    this.isHiringDetailsTabRefresh = !this.isHiringDetailsTabRefresh;
  }

  toggleHistoryDetailsComponent() {
    this.isHistoryDetailsTabRefresh = !this.isHistoryDetailsTabRefresh;
  }

  SaveEducationDetails(value) {
    this.loader = true;
    window.scrollTo(0, 0);
    this.datePipe = new DatePipe("en-US");
    //check whether all the validations in the form are satisfied
    if (!this.educationDetailsComponent.EducationDetailForm.invalid) {
      this.educationDetailsComponent.assignDocumentsListToObject();
      for (var i = 0; i < this.rows.value.length; i++) {
        this.rows.value[i].EmpCode = this.empCode;
        this.rows.value[i].ModifiedBy = this.LoginEmpCode;
        //check whether any documents are attached to each qualification
        if (
          isNullOrUndefined(this.rows.value[i].OnboardHREmpDocs) ||
          this.rows.value[i].OnboardHREmpDocs.length < 1
        ) {
          this.toastr.warning(
            "One attachment is mandatory for your qualification " +
              this.rows.value[i].Qualification
          );
          this.loader = false;
          return;
        }
        if (this.rows.value[i].OnboardHREmpDocs.length > 0) {
          if (
            isNullOrUndefined(this.rows.value[i].Qualification) ||
            this.rows.value[i].Qualification == "" ||
            isNullOrUndefined(this.rows.value[i].MarksPercent) ||
            this.rows.value[i].MarksPercent == "" ||
            isNullOrUndefined(this.rows.value[i].YearOfPassing) ||
            (this.rows.value[i].YearOfPassing != null &&
              this.rows.value[i].YearOfPassing.toString() == "") ||
            isNullOrUndefined(this.rows.value[i].University) ||
            this.rows.value[i].University == ""
          ) {
            this.toastr.warning("Please fill the required fields");
            this.loader = false;
            return;
          }
          if (this.rows.value[i].YearOfPassing === "0000") {
            this.toastr.warning("Year of Passing cannot be all zeros.");
            this.loader = false;
            return;
          }
        }
        if (value == true) {
          this.SaveVerificationDetails(this.selectedIndex + 1);
          this.rows.value[i].profileVerification = this.Verify;
        } else {
          this.rows.value[i].profileVerification = null;
        }
        //just assigned the documents list to another object to overcome the issue of matching the object names in api
        this.rows.value[i].HREmpDocs = this.rows.value[i].OnboardHREmpDocs;
      }
      this.educationInfo.educationDetails = this.rows.value;
    } else {
      this.toastr.warning("Please fill the required fields");
      this.loader = false;
      return;
    }
    //Check whether employee contains additional qualifications
    if (
      this.additionalQualifications != null &&
      this.additionalQualifications.length != 0
    ) {
      var count = 0;
      this.educationInfo.AdditionalQualifications = [];
      for (var i = 0; i < this.additionalQualifications.length; i++) {
        //checks the name field contains value or not
        if (
          !isNullOrUndefined(this.additionalQualifications[i].Name) &&
          this.additionalQualifications[i].Name != ""
        ) {
          if (
            !this.isEmptyOrSpaces(this.additionalQualifications[i].Name) &&
            isNullOrUndefined(this.additionalQualifications[i].additionalDocs)
          ) {
            this.toastr.warning(
              "One attachment is mandatory for your additional qualification " +
                this.additionalQualifications[i].Name
            );
            this.loader = false;
            return;
          }
        }
        // if name field is empty and doc is attached ,name should also be entered
        else if (
          isNullOrUndefined(this.additionalQualifications[i].Name) ||
          this.additionalQualifications[i].Name == ""
        ) {
          if (
            !isNullOrUndefined(this.additionalQualifications[i].additionalDocs)
          ) {
            this.toastr.warning(
              "Please provide the Name of the Qualification/Certification"
            );
            this.loader = false;
            return;
          }
        }
        //assign additional qualifications data to the education info object
        if (
          !isNullOrUndefined(this.additionalQualifications[i].additionalDocs)
        ) {
          for (
            var j = 0;
            j < this.additionalQualifications[i].additionalDocs.length;
            j++
          ) {
            this.educationInfo.AdditionalQualifications =
              this.educationInfo.AdditionalQualifications.concat(
                this.additionalQualifications[i].additionalDocs[j]
              );
            this.educationInfo.AdditionalQualifications[count].EmpCode =
              this.empCode;
            this.educationInfo.AdditionalQualifications[count].ModifiedBy =
              this.LoginEmpCode;
            this.educationInfo.AdditionalQualifications[count].DocTypeName =
              this.additionalQualifications[i].Name;
            count++;
          }
        }
      }
    }
    this.educationInfo = {
      ...this.educationInfo,
      isFromProfile: this.isProfile,
    };
    this.emp_Svc.SaveEmpEducationDetails(this.educationInfo).subscribe(
      (data: any) => {
        this.toastr.success("Saved Successfully");
        this.loader = false;
       // this.toggleEducationDetailsComponent();
        // this.educationDetailsComponent.getRefreshPage()
        this.educationDetailsComponent.getHREmpData();
        if (value) {
          this.changeTab();
        }
      },
      (error) => (this.error = error)
    );
  }

  GetPrevEmploymentDetails() {
    this.loader = true;
    window.scrollTo(0, 0);
    this.datePipe = new DatePipe("en-US");
    this.previousEmploymentComponent.assignDocumentsListToObject();
    const prevEmpDetails =
      this.previousEmploymentComponent.GetPriorExperience();
    if (prevEmpDetails != null) {
      this.PriorExperienceYears = prevEmpDetails.PriorExperienceYears;
      this.PriorExperienceMonths = prevEmpDetails.PriorExperienceMonths;
    }

    for (var i = 0; i < this.prevEmp.value.length; i++) {
      this.prevEmp.value[i].EmpCode = this.empCode;
      if (!isNullOrUndefined(this.prevEmp.value[i].FromDate)) {
        this.prevEmp.value[i].FromDate = new Date(
          this.datePipe.transform(
            this.prevEmp.value[i].FromDate,
            this.config.dateFormat()
          )
        );
      }
      if (!isNullOrUndefined(this.prevEmp.value[i].ToDate)) {
        this.prevEmp.value[i].ToDate = new Date(
          this.datePipe.transform(
            this.prevEmp.value[i].ToDate,
            this.config.dateFormat()
          )
        );
      }
      this.prevEmp.value[i].HREmpDocs = this.prevEmp.value[i].OnboardHREmpDocs;
      this.prevEmp.value[i].ModifiedBy = this.LoginEmpCode;
    }

    this.empPreviousEmploymentDetails = new EmpPreviousEmploymentDetails();
    this.empPreviousEmploymentDetails.hrEmpPreviousEmploymentDtls =
      this.prevEmp.value;
    this.empPreviousEmploymentDetails.PriorExperienceYears =
      this.PriorExperienceYears;
    this.empPreviousEmploymentDetails.PriorExperienceMonths =
      this.PriorExperienceMonths;
    return this.empPreviousEmploymentDetails;
  }

  //returns true if given string is empty or had spaces
  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }
  SavePrevEmploymentDetails(value) {
    this.loader = true;
    window.scrollTo(0, 0);
    this.previousEmploymentComponent.PrevEmploymentDetForm.markAllAsTouched();
    this.previousEmploymentComponent.detectChanges();
    //this.previousEmploymentComponent.markDatesAsTouched();
    this.datePipe = new DatePipe("en-US");
    this.previousEmploymentComponent.assignDocumentsListToObject();
    const prevEmpDetails =
      this.previousEmploymentComponent.GetPriorExperience();
    if (prevEmpDetails != null) {
      this.PriorExperienceYears = prevEmpDetails.PriorExperienceYears;
      this.PriorExperienceMonths = prevEmpDetails.PriorExperienceMonths;
    }

    for (let i = 0; i < this.referenceDetails.length; i++) {
      const contactPhoneNumber = this.referenceDetails[i].ContactPhoneNumber;
      if (!isNullOrUndefined(contactPhoneNumber)) {
        if (contactPhoneNumber.length !== 10) {
          this.toastr.warning("Please enter a valid 10-digit Phone Number");
          this.loader = false;
          return;
        }
      }
    }
    for (var i = 0; i < this.prevEmp.value.length; i++) {
      this.prevEmp.value[i].EmpCode = this.empCode;
      const date =
        this.previousEmploymentComponent.getBasicEmployeeByCodeforDate();
      if (!isNullOrUndefined(this.prevEmp.value[i].FromDate)) {
        this.prevEmp.value[i].FromDate = new Date(
          this.datePipe.transform(
            this.prevEmp.value[i].FromDate,
            this.config.dateFormat()
          )
        );
      }
      if (!isNullOrUndefined(this.prevEmp.value[i].ToDate)) {
        this.prevEmp.value[i].ToDate = new Date(
          this.datePipe.transform(
            this.prevEmp.value[i].ToDate,
            this.config.dateFormat()
          )
        );
      }
      if (
        this.prevEmp.value[i].FromDate != null &&
        this.prevEmp.value[i].ToDate != null &&
        this.prevEmp.value[i].FromDate > this.prevEmp.value[i].ToDate
      ) {
        this.toastr.warning("From Date should not be greater than To Date");
        this.loader = false;
        return;
      }
      if (
        this.prevEmp.value[i].FromDate != null &&
        this.prevEmp.value[i].FromDate > date
      ) {
        this.toastr.warning(
          "From Date should be less than " +
            formatDate(date, "dd-MMM-yyyy", "en_US")
        );
        this.loader = false;
        return;
      }
      //if (
      //  this.prevEmp.value[i].ToDate != null &&
      //  formatDate(this.prevEmp.value[i].ToDate, "dd-MM-yyyy", "en_US") > formatDate(date, "dd-MM-yyyy", "en_US")
      //) {
      //  this.toastr.warning(
      //    "To Date should be less than " +
      //      formatDate(date, "dd-MMM-yyyy", "en_US")
      //  );
      //  this.loader = false;
      //  return;
      //}
      if (
        this.prevEmp.value[i].ToDate != null &&
        new Date(this.prevEmp.value[i].ToDate).getTime() >
          new Date(date).getTime()
      ) {
        this.toastr.warning(
          "To Date should be less than " +
            formatDate(date, "dd-MMM-yyyy", "en_US")
        );
        this.loader = false;
        return;
      }
      if (value == true) {
        this.SaveVerificationDetails(this.selectedIndex + 1);
        this.prevEmp.value[i].profileVerification = this.Verify;
      } else {
        this.prevEmp.value[i].profileVerification = null;
      }
      if (
        !this.isEmptyOrSpaces(this.prevEmp.value[i].CompanyName) ||
        this.prevEmp.value[i].CompanyName != ""
      ) {
        if (
          ((this.isEmptyOrSpaces(this.prevEmp.value[i].Designation) ||
            this.prevEmp.value[i].Designation == "") &&
            (this.isEmptyOrSpaces(this.prevEmp.value[i].JobLocation) ||
              this.prevEmp.value[i].JobLocation == "")) ||
          (isNullOrUndefined(this.prevEmp.value[i].ToDate) &&
            isNullOrUndefined(this.prevEmp.value[i].FromDate))
        ) {
          this.toastr.warning(
            "Please fill the remaining fields for " +
              this.prevEmp.value[i].CompanyName
          );
          this.loader = false;
          return;
        }
        //if any field has value then attachment of document is madatory
        if (
          isNullOrUndefined(this.prevEmp.value[i].OnboardHREmpDocs) ||
          this.prevEmp.value[i].OnboardHREmpDocs.length < 1
        ) {
          this.toastr.warning(
            "One attachment is mandatory for your experience in " +
              this.prevEmp.value[i].CompanyName
          );
          this.loader = false;
          return;
        }
        if (
          this.prevEmp.value[i].OnboardHREmpDocs != null &&
          this.prevEmp.value[i].OnboardHREmpDocs != "" &&
          this.prevEmp.value[i].OnboardHREmpDocs.length > 0
        ) {
          if (
            this.prevEmp.value[i].Designation == "" ||
            this.prevEmp.value[i].JobLocation == "" ||
            isNullOrUndefined(this.prevEmp.value[i].ToDate) ||
            isNullOrUndefined(this.prevEmp.value[i].FromDate) ||
            this.prevEmp.value[i].CompanyName == ""
          ) {
            this.toastr.warning("Please fill the required fields");
            this.loader = false;
            return;
          }
        }
      } else {
        if (
          (!this.isEmptyOrSpaces(this.prevEmp.value[i].Designation) &&
            this.prevEmp.value[i].Designation != "" &&
            !this.isEmptyOrSpaces(this.prevEmp.value[i].JobLocation) &&
            this.prevEmp.value[i].JobLocation != "") ||
          (!isNullOrUndefined(this.prevEmp.value[i].ToDate) &&
            !isNullOrUndefined(this.prevEmp.value[i].FromDate))
        ) {
          if (
            this.isEmptyOrSpaces(this.prevEmp.value[i].CompanyName) ||
            this.prevEmp.value[i].CompanyName == ""
          ) {
            this.toastr.warning(
              "Please enter company name in previous employment."
            );
            this.loader = false;
            return;
          }
        }
      }
      if (
        this.prevEmp.value[i].OnboardHREmpDocs != null &&
        this.prevEmp.value[i].OnboardHREmpDocs.length > 0
      ) {
        if (
          this.prevEmp.value[i].Designation == "" ||
          this.prevEmp.value[i].JobLocation == "" ||
          isNullOrUndefined(this.prevEmp.value[i].ToDate) ||
          isNullOrUndefined(this.prevEmp.value[i].FromDate) ||
          this.prevEmp.value[i].CompanyName == ""
        ) {
          this.toastr.warning("Please fill the required fields");
          this.loader = false;
          return;
        }
      }
      //just assigned the documents list to another object to overcome the issue of matching the object names in api
      this.prevEmp.value[i].HREmpDocs = this.prevEmp.value[i].OnboardHREmpDocs;
      this.prevEmp.value[i].ModifiedBy = this.LoginEmpCode;
    }
    if (
      this.prevEmp.value.length > 0 &&
      !isNullOrUndefined(this.prevEmp.value[0].CompanyName) &&
      this.prevEmp.value[0].CompanyName !== ""
    ) {
      for (var i = 0; i < this.referenceDetails.length; i++) {
        this.referenceDetails[i].EmpCode = this.empCode;
        this.referenceDetails[i].ModifiedBy = this.LoginEmpCode;

        if (
          !isNullOrUndefined(this.referenceDetails[0].Company) ||
          !isNullOrUndefined(this.prevEmp.value[i].CompanyName)
        ) {
          if (!isNullOrUndefined(this.referenceDetails[0].Company)) {
            if (this.referenceDetails[0].Company != "") {
              if (
                isNullOrUndefined(this.referenceDetails[0].ContactPersonName) ||
                isNullOrUndefined(
                  this.referenceDetails[0].ContactPhoneNumber
                ) ||
                isNullOrUndefined(this.referenceDetails[0].ContactInfo) ||
                this.referenceDetails[0].ContactInfo == "" ||
                this.referenceDetails[0].ContactPersonName == "" ||
                this.referenceDetails[0].ContactPhoneNumber == ""
              ) {
                this.toastr.warning(
                  "Please fill the remaining fields for " +
                    this.referenceDetails[0].Company
                );
                return;
              }
            } else {
              this.toastr.warning(
                "Please enter Company name for " +
                  this.prevEmp.value[i].CompanyName
              );
              return;
            }
          } else {
            this.toastr.warning(
              "One reference detail is required for your experience in " +
                this.prevEmp.value[0].CompanyName
            );
            return;
          }
        }
      }

      for (var i = 1; i < this.referenceDetails.length; i++) {
        if (
          isNullOrUndefined(this.referenceDetails[i].ContactPersonName) ||
          isNullOrUndefined(this.referenceDetails[i].ContactPhoneNumber) ||
          isNullOrUndefined(this.referenceDetails[i].ContactInfo) ||
          this.referenceDetails[i].ContactPersonName === "" ||
          this.referenceDetails[i].ContactPhoneNumber === "" ||
          this.referenceDetails[i].ContactInfo === ""
        ) {
          this.toastr.warning("Please fill the remaining fields");
          return;
        }
      }
    }
    this.empPreviousEmploymentDetails = new EmpPreviousEmploymentDetails();
    this.empPreviousEmploymentDetails.hrEmpPreviousEmploymentDtls =
      this.prevEmp.value;
    this.empPreviousEmploymentDetails.PriorExperienceYears =
      this.PriorExperienceYears;
    this.empPreviousEmploymentDetails.PriorExperienceMonths =
      this.PriorExperienceMonths;

    this.emp_Svc
      .SavePrevEmploymentDetails(this.empPreviousEmploymentDetails)
      .subscribe(
        (data: any) => {
          this.previousEmploymentComponent.GetHREmpPrevEmploymentDetails();
          //if value is true then it is moved to next tab
          // if (value) { this.changeTab(); }
        },
        (error) => (this.error = error)
      );
    this.emp_Svc.SaveReferenceDetails(this.referenceDetails).subscribe(
      (data: any) => {
        this.previousEmploymentComponent.GetHREmpReferences();
        this.toastr.success("Saved Successfully");
        this.loader = false;
       // this.togglePreviousDetailsComponent();
        // this.previousEmploymentComponent.getRefreshPage()
        //if value is true then it is moved to next tab
        if (value) {
          this.changeTab();
        }
      },
      (error) => (this.error = error)
    );
  }

  async getAllEmployees() {
    this.isLoader = true;
    try {
      const data: BasicEmployeeDetails[] = await this.emp_Svc
        .getAllEmployees()
        .toPromise();
      this.EmployeeList = data || [];
      this.isLoader = false;
    } catch (error) {
      this.error = error;
      this.isLoader = false;
    }
  }

  getDetailsByGroupID(groupID: string): Promise<{ result: boolean; emp: any }> {
    return new Promise((resolve, reject) => {
      this.emp_Svc.getEmployeeDetailsByGroupId(groupID).subscribe(
        (data: any) => {
          this.EmpGroupIDDetails = data;
          const emp = this.EmpGroupIDDetails.IsMigratedOnH1
            ? new Date(this.EmpGroupIDDetails.US_DOE)
            : new Date(this.EmpGroupIDDetails.DateOfExit);
          emp.setHours(0, 0, 0, 0);
          const empDate = emp.getTime();
          const doj = new Date(this.HrEmpDtls.DOJ);
          doj.setHours(0, 0, 0, 0);
          const dojDate = doj.getTime();
          if (isNaN(empDate) || isNaN(dojDate)) {
            reject(false);
            return;
          }

          const result = empDate >= dojDate;

          // Resolve with the result and emp
          resolve({ result, emp });
        },
        (error) => {
          console.error("Error fetching employee details:", error);
          reject(false);
        }
      );
    });
  }

  removeNullObjects(array: any[]): any[] {
    return array.filter((obj) =>
      Object.values(obj).some((value) => value !== null)
    );
  }

    async SaveHrEmployeeDetails(value) {
      await this.getEmployeeList();
      await this.getAllEmployees();
      this.HrEmpDtls = this.hrBasicDetailsComponent.sendBasicDetails();
      this.skillsetDetails = this.skillsetComponent.sendDetails();
      var team = this.skillsetComponent.getTeamValue(this.HrEmpDtls.TeamId)
    if (isNullOrUndefined(this.empCode) && this.groupId == null) {
      this.isNewRecord = true;
      this.HrEmpDtls.GroupId = null;
    }
    var linkedInUrlPattern = /^(https?:\/\/)?(www\.)?(linkedin\.com\/.*)$/;
    if (
      this.HrEmpDtls.LinkedInID != null &&
      this.HrEmpDtls.LinkedInID.trim() != "" &&
      !linkedInUrlPattern.test(this.HrEmpDtls.LinkedInID)
    ) {
      this.hrBasicDetailsComponent.isInvalidUrl = true;
    }
    window.scrollTo(0, 0);
    this.hrBasicDetailsComponent.HrDetailsForm.markAllAsTouched();
    this.hrBasicDetailsComponent.EmpDetform.markAllAsTouched();
    this.hrEmpCommunicationDetailsComponent.EmpAddform.markAllAsTouched();
    this.skillsetComponent.Skillsetform.markAllAsTouched();
    this.datePipe = new DatePipe("en-US");
    if (this.hrBasicDetailsComponent.isInvalidUrl) {
      this.toastr.warning("Please enter valid LinkedIn URL");
      this.loader = false;
      return;
      }
      if (!isNullOrUndefined(this.HrEmpDtls.ResignationDate)) {
        this.HrEmpDtls.ResignationDate = new Date(
          this.datePipe.transform(this.HrEmpDtls.ResignationDate, this.config.dateFormat())
        );
      }
    if (
      this.HrEmpDtls.ResignationDate != null &&
      this.hrBasicDetailsComponent.HrDetailsForm.controls.ResignationDate
        .errors != null &&
      this.hrBasicDetailsComponent.HrDetailsForm.controls.ResignationDate.errors
        .matDatepickerMax
    ) {
      this.toastr.warning(
        "Resignation Date should be earlier than" +
          formatDate(new Date(), "dd-MMM-yyyy", "en_US")
      );
      this.loader = false;
      return;
    }
    if (
      this.HrEmpDtls.ResignationDate != null &&
      this.hrBasicDetailsComponent.HrDetailsForm.controls.ResignationDate
        .errors != null &&
      this.hrBasicDetailsComponent.HrDetailsForm.controls.ResignationDate.errors
        .matDatepickerMin
    ) {
      this.toastr.warning(
        "Resignation Date should be on or after " +
          formatDate(this.HrEmpDtls.DOJ, "dd-MMM-yyyy", "en_US")
      );
      this.loader = false;
      return;
    }
    if (
      this.HrEmpDtls.DateOfExit != null &&
      this.hrBasicDetailsComponent.HrDetailsForm.controls.DateOfExit.errors !=
        null &&
      this.hrBasicDetailsComponent.HrDetailsForm.controls.DateOfExit.errors
        .matDatepickerMin
    ) {
      this.toastr.warning(
        "Resignation Date should be on or after " +
          formatDate(this.HrEmpDtls.ResignationDate, "dd-MMM-yyyy", "en_US")
      );
      this.loader = false;
      return;
    }
    //check whether all the validations in the form are satisfied
    if (this.HrEmpDtls.DOJ != null && this.HrEmpDtls.DOJ != null) {
      var min = new Date(this.HrEmpDtls.DOJ);
      min.setFullYear(min.getFullYear() - 18);
      if (
        new Date(
          this.datePipe.transform(this.HrEmpDtls.DOB, this.config.dateFormat())
        ) > new Date(this.datePipe.transform(min, this.config.dateFormat()))
      ) {
        this.toastr.warning("Please select valid DOB");
        this.loader = false;
        this.messageHideVariableBasic = false;
        return;
      }
    }
    if (
      this.HrEmpDtls.IsMigratedOnH1 &&
      this.HrEmpDtls.US_DOJ != null &&
      this.HrEmpDtls.US_DOE != null &&
      this.HrEmpDtls.US_DOJ > this.HrEmpDtls.US_DOE
    ) {
      this.toastr.warning("Please select valid US_DOE");
      this.loader = false;
      this.messageHideVariableBasic = false;
      return;
    }
    const controls = this.hrBasicDetailsComponent.HrDetailsForm.controls;

    //for (const controlName in controls) {
    //  if (controls[controlName].invalid) {
    //    console.log(`${controlName} is invalid`);
    //  }
    //}
    if (this.hrBasicDetailsComponent.HrDetailsForm.invalid) {
      if (
        this.hrBasicDetailsComponent.HrDetailsForm.controls.SecondaryEmail
          .errors != null &&
        this.HrEmpDtls.SecondaryEmail != null &&
        this.HrEmpDtls.SecondaryEmail != "" &&
        this.hrBasicDetailsComponent.HrDetailsForm.controls.SecondaryEmail
          .errors.emailDomain
      ) {
        this.toastr.warning("Domain should not be winwire for personal email");
        this.loader = false;
        this.messageHideVariableBasic = false;
        return;
      }
      this.toastr.warning("Please fill the required fields.");
      this.loader = false;
      this.messageHideVariableBasic = false;
      return;
    }
    if (this.hrBasicDetailsComponent.EmpDetform.invalid) {
      this.toastr.warning("Please fill the required fields.");
      this.loader = false;
      this.messageHideVariableBasic = false;
      return;
    }

    if (this.hrEmpCommunicationDetailsComponent.EmpAddform.invalid) {
      this.toastr.warning(
        "please fill all the details in the communication address"
      );
      this.loader = false;
      this.messageHideVariableBasic = false;
      return;
    }

    const pinCodeValue =
      this.hrEmpCommunicationDetailsComponent.EmpAddform.get("PinCode")!.value;

    if (pinCodeValue && pinCodeValue.length < 5) {
      this.toastr.warning("Pincode must be at least 5 digits");
      return;
    }

    //if ((this.HrEmpDtls.LocationID == this.HrEmpDtls.OldIndLocationID) && this.HrEmpDtls.IsMigratedOnH1) {
    //  this.toastr.warning("Location and lod location cannot be the same");
    //  this.loader = false;
    //  return;
    //}

    if (
      this.hrBasicDetailsComponent.HrDetailsForm.controls.EmployeeCode
        .disabled == false ||
      this.hrBasicDetailsComponent.HrDetailsForm.controls.OfficeMailId
        .disabled == false
    ) {
      this.duplicatemp = this.empList.filter(
        (emp) =>
          this.HrEmpDtls.EmpCode == emp.EmpCode &&
          (emp.IsMigratedOnH1 ? emp.US_DOE == null : emp.DateOfExit == null)
      );
      this.emailemp = this.empList.filter(
        (emp) =>
          this.HrEmpDtls.Email.toLowerCase() == emp.Email.toLowerCase() &&
          (emp.IsMigratedOnH1 ? emp.US_DOE == null : emp.DateOfExit == null)
      );
      var duplicateEmployee = this.empList.filter(
        (emp) =>
          this.HrEmpDtls.EmpCode == emp.EmpCode &&
          this.HrEmpDtls.Email.toLowerCase() == emp.Email.toLowerCase() &&
          (emp.IsMigratedOnH1 ? emp.US_DOE != null : emp.DateOfExit != null)
      );

      if (
        this.duplicatemp.length != 0 ||
        this.emailemp.length != 0 ||
        duplicateEmployee.length != 0
      ) {
        if (
          (this.duplicatemp.length >= 1 && this.emailemp.length >= 1) ||
          duplicateEmployee.length >= 1
        ) {
          this.toastr.warning("Same Employee code and Email exists");
          this.loader = false;
          return;
        } else if (this.emailemp.length >= 1) {
          this.toastr.warning("Same Email exists");
          this.loader = false;
          return;
        } else if (this.duplicatemp.length >= 1) {
          this.toastr.warning("Same Employee code  exists");
          this.loader = false;
          return;
        }
      }
    }
    this.HrEmpDtls.ModifiedBy = this.LoginEmpCode;
    //condition to check whether dob has value
    if (value == true) {
      this.SaveVerificationDetails(this.selectedIndex + 1);
      this.HrEmpDtls.profileVerification = this.Verify;
    } else {
      this.HrEmpDtls.profileVerification = null;
    }
    if (this.messageHideVariableBasic == true) {
      if (value == false) {
        this.SaveVerificationDetails(1);
        this.HrEmpDtls.profileVerification = this.Verify;
        //this.HrEmpDtls.profileVerification.Submitted = true;
        //this.HrEmpDtls.twoTabProfile = true;
      } else {
        this.HrEmpDtls.profileVerification = null;
      }
    }
    if (!isNullOrUndefined(this.HrEmpDtls.DOB)) {
      this.HrEmpDtls.DOB = new Date(
        this.datePipe.transform(this.HrEmpDtls.DOB, this.config.dateFormat())
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.ProbationDate)) {
      this.HrEmpDtls.ProbationDate = new Date(
        this.datePipe.transform(
          this.HrEmpDtls.ProbationDate,
          this.config.dateFormat()
        )
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.US_DOJ)) {
      this.HrEmpDtls.US_DOJ = new Date(
        this.datePipe.transform(this.HrEmpDtls.US_DOJ, this.config.dateFormat())
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.GMCInclusion)) {
      this.HrEmpDtls.GMCInclusion = new Date(
        this.datePipe.transform(
          this.HrEmpDtls.GMCInclusion,
          this.config.dateFormat()
        )
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.GPAInclusion)) {
      this.HrEmpDtls.GPAInclusion = new Date(
        this.datePipe.transform(
          this.HrEmpDtls.GPAInclusion,
          this.config.dateFormat()
        )
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.US_DOE)) {
      this.HrEmpDtls.US_DOE = new Date(
        this.datePipe.transform(this.HrEmpDtls.US_DOE, this.config.dateFormat())
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.DOJ)) {
      this.HrEmpDtls.DOJ = new Date(
        this.datePipe.transform(this.HrEmpDtls.DOJ, this.config.dateFormat())
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.CelebratedDOB)) {
      this.HrEmpDtls.CelebratedDOB = new Date(
        this.datePipe.transform(
          this.HrEmpDtls.CelebratedDOB,
          this.config.dateFormat()
        )
      );
    }
    if (!isNullOrUndefined(this.HrEmpDtls.DateOfExit)) {
      this.HrEmpDtls.DateOfExit = new Date(
        this.datePipe.transform(
          this.HrEmpDtls.DateOfExit,
          this.config.dateFormat()
        )
      );
    }
    this.HrEmpDtls.peopleManagersHistoryDetails.forEach((obj) => {
      if (!isNullOrUndefined(obj.DurationFrom)) {
        obj.DurationFrom = new Date(
          this.datePipe.transform(obj.DurationFrom, this.config.dateFormat())
        );
      }
      if (!isNullOrUndefined(obj.DurationTo)) {
        obj.DurationTo = new Date(
          this.datePipe.transform(obj.DurationTo, this.config.dateFormat())
        );
      }
      if (isNullOrUndefined(obj.CreatedBy)) {
        obj.CreatedBy = this.LoginEmpCode;
      }
      obj.EmpCode = this.HrEmpDtls.EmpCode;
    });
    this.HrEmpDtls.peopleManagersHistoryDetails =
      this.HrEmpDtls.peopleManagersHistoryDetails.filter(
        (record) => record.ManagerCode != undefined && record.ManagerCode > 0
      );
    this.HrEmpDtls.seniorManagersHistoryDetails =
      this.HrEmpDtls.seniorManagersHistoryDetails.filter(
        (record) =>
          record.SeniorManagerCode != undefined && record.SeniorManagerCode > 0
      );
    this.HrEmpDtls.seniorManagersHistoryDetails.forEach((obj) => {
      if (!isNullOrUndefined(obj.DurationFrom)) {
        obj.DurationFrom = new Date(
          this.datePipe.transform(obj.DurationFrom, this.config.dateFormat())
        );
      }
      if (!isNullOrUndefined(obj.DurationTo)) {
        obj.DurationTo = new Date(
          this.datePipe.transform(obj.DurationTo, this.config.dateFormat())
        );
      }
      if (isNullOrUndefined(obj.CreatedBy)) {
        obj.CreatedBy = this.LoginEmpCode;
      }
      obj.EmpCode = this.HrEmpDtls.EmpCode;

      if (obj.smDisplayName == null) {
        // this.HrEmpDtls.seniorManagersHistoryDetails.pop();
      }
    });
    if (this.skillsetDetails != null) {
      if (
        this.skillsetDetails.TechGroupId != null &&
        (this.skillsetDetails.StreamId == null ||
          this.skillsetDetails.PrimarySkillId == null)
      ) {
        this.toastr.warning("Please fill the required fields.");
        this.loader = false;
        return;
      }
      this.HrEmpDtls.TechGroupId = this.skillsetDetails.TechGroupId;
      this.HrEmpDtls.TechGroupName = this.skillsetDetails.TechGroupName;
      this.HrEmpDtls.StreamId = this.skillsetDetails.StreamId;
      this.HrEmpDtls.PrimarySkillId =
        this.skillsetDetails.PrimarySkillId != null
          ? this.skillsetDetails.PrimarySkillId.join(",")
          : this.skillsetDetails.PrimarySkillId;
      this.HrEmpDtls.employeeAdditionalSkills = [];
      if (
        this.skillsetDetails.employeeAdditionalSkills != null &&
        this.skillsetDetails.employeeAdditionalSkills.length > 0
      ) {
        this.skillsetDetails.employeeAdditionalSkills = this.removeNullObjects(
          this.skillsetDetails.employeeAdditionalSkills
        );
      }
      if (
        this.skillsetDetails.employeeAdditionalSkills != null &&
        this.skillsetDetails.employeeAdditionalSkills.length > 0
      ) {
        for (
          var i = 0;
          i < this.skillsetDetails.employeeAdditionalSkills.length;
          i++
        ) {
          this.HrEmpDtls.employeeAdditionalSkills.push(
            new EmployeeAdditionalSkills()
          );
          if (
            this.skillsetDetails.employeeAdditionalSkills[i].TechGroupId !=
              null &&
            this.skillsetDetails.employeeAdditionalSkills[i].SkillId == null
          ) {
            this.toastr.warning("Please fill the required fields.");
            this.loader = false;
            return;
          }

          var details = this.skillsetDetails.employeeAdditionalSkills[i];
          this.HrEmpDtls.employeeAdditionalSkills[i].CreatedBy =
            details.CreatedBy == null || details.CreatedBy == ""
              ? this.LoginEmpCode
              : details.CreatedBy;
          this.HrEmpDtls.employeeAdditionalSkills[i].Id = details.Id;
          this.HrEmpDtls.employeeAdditionalSkills[i].EmpCode = this.empCode;
          this.HrEmpDtls.employeeAdditionalSkills[i].TechGroupId =
            details.TechGroupId;
          this.HrEmpDtls.employeeAdditionalSkills[i].SkillId =
            details.SkillId != null
              ? details.SkillId.join(",")
              : details.SkillId;
          this.HrEmpDtls.employeeAdditionalSkills[i].CreatedDate =
            details.CreatedDate;
          this.HrEmpDtls.employeeAdditionalSkills[i].ModifiedBy =
            this.LoginEmpCode;
          this.HrEmpDtls.employeeAdditionalSkills[i].ModifiedDate =
            details.ModifiedDate;

          const existingSkillWithTechGroup =
            this.HrEmpDtls.employeeAdditionalSkills.find(
              (existingSkill, index) =>
                existingSkill.TechGroupId === details.TechGroupId && index !== i
            );

          if (existingSkillWithTechGroup) {
            this.toastr.warning(
              "Techgroup must be unique in additional skills."
            );
            this.loader = false;
            return;
          }
        }
      }
    }

    this.HrEmpDtls.CreatedBy = this.LoginEmpCode;
    this.employeeDetails.Aadhar =
      this.hrBasicDetailsComponent.employeeDetails.Aadhar;
    this.employeeDetails.PAN = this.hrBasicDetailsComponent.employeeDetails.PAN;
    this.employeeDetails.Aadharfile =
      this.hrBasicDetailsComponent.employeeDetails.Aadharfile;
    this.employeeDetails.Panfile =
      this.hrBasicDetailsComponent.employeeDetails.Panfile;
    if (!isNullOrUndefined(this.HrEmpDtls.ExpertiseId)) {
      this.HrEmpDtls.ExpertiseId = this.HrEmpDtls.ExpertiseId.toString();
      }
      if (team != null && team == "Offshore" && (this.skillsetDetails.TechGroupId == null || this.skillsetDetails.TechGroupId == '')) {
        this.toastr.warning("Please fill the required fields.");
        this.loader = false;
        return;
      }
    this.HrEmpDtls.employeeDetails = this.employeeDetails;
    if (this.isNewRecord) {
      var shouldReturn = false;
      var employee =
        this.EmployeeList != null
          ? this.EmployeeList.filter(
              (emp) =>
                ((emp.PAN != null &&
                  this.HrEmpDtls.employeeDetails.PAN != null &&
                  emp.PAN == this.HrEmpDtls.employeeDetails.PAN) ||
                  (emp.Aadhar != null &&
                    this.HrEmpDtls.employeeDetails.Aadhar != null &&
                    emp.Aadhar == this.HrEmpDtls.employeeDetails.Aadhar) ||
                  (emp.SecondaryEmail == this.HrEmpDtls.SecondaryEmail &&
                    formatToCustomDate(emp.DOB) ===
                      formatToCustomDate(this.HrEmpDtls.DOB))) &&
                this.HrEmpDtls.GroupId != emp.GroupId
            ).pop()
          : null;
      if (
        employee != null &&
        employee != undefined &&
        this.HrEmpDtls.Type !== "Re-hire"
      ) {
        if (
          (employee.IsMigratedOnH1
            ? employee.US_DOE == null
            : employee.DateOfExit == null) &&
          employee.EmpCode != this.HrEmpDtls.EmpCode
        ) {
          this.toastr.warning(
            "PAN/Aadhar/Email & DOB is matching with the group Id " +
              employee.GroupId +
              ". Date of exit is null for earlier record/s"
          );
          this.loader = false;
          return;
        } else if (
          employee.IsMigratedOnH1 == true
            ? employee.US_DOE != null
            : employee.DateOfExit != null &&
              this.HrEmpDtls.GroupId != employee.GroupId
        ) {
          if (
            confirm(
              "PAN/Aadhar/Email & DOB is matching with the group Id " +
                employee.GroupId +
                ". Click OK to use this " +
                employee.GroupId +
                " or cancel to review and modify the details."
            )
          ) {
            this.HrEmpDtls.GroupId = employee.GroupId;
            this.HrEmpDtls.Type == "Re-hire";
            try {
              const data = await this.getDetailsByGroupID(
                this.HrEmpDtls.GroupId
              );
              if (data.result) {
                this.toastr.warning(
                  "PAN/Aadhar/Email & DOB is matching with the group Id " +
                    employee.GroupId +
                    ". DOJ should be after the earlier Date of exit " +
                    formatDate(data.emp, "dd-MMM-yyyy", "en_US")
                );
                shouldReturn = true;
                this.loader = false;
                return;
              }
            } catch (error) {
              console.error(error);
              this.loader = false;
            }
          } else {
            this.loader = false;
            return;
          }
        }
        if (shouldReturn) {
          this.loader = false;
          return;
        }

        if (
          employee.IsMigratedOnH1 == true
            ? employee.US_DOE != null
            : employee.DateOfExit != null &&
              employee.EmpCode != this.HrEmpDtls.EmpCode
        ) {
          const data = await this.getDetailsByGroupID(this.HrEmpDtls.GroupId);
          if (data.result) {
            this.loader = false;
            this.toastr.warning(
              "PAN/Aadhar/Email & DOB is matching with the group Id " +
                employee.GroupId +
                ". DOJ should be after the earlier Date of exit " +
                formatDate(data.emp, "dd-MMM-yyyy", "en_US")
            );
            return;
          } else {
            this.checkProfileSubmitBasic = true;
            this.HrEmpDtls = {
              ...this.HrEmpDtls,
              isFromProfile: this.isProfile,
            };
            this.emp_Svc.SaveHrEmployeeDetails(this.HrEmpDtls).subscribe(
              (data: any) => {
                // console.log("=========this.HrEmpDtls======", this.HrEmpDtls, this.HrEmpDtls.employeeDetails)
                if (!isNullOrUndefined(data.ErrorMsg)) {
                  //Incase of new employee creation the created employee code is returned from api.
                  //returned empcode in data is assigned to empCode to use for the remaining tabs
                  this.empCode = data.ErrorMsg;
                }
                //this.hrBasicDetailsComponent.getCommunicationData();
                //this.hrEmpCommunicationDetailsComponent.getCommunicationData();
               // this.toggleBasicDetailsComponent();
                //this.hrBasicDetailsComponent.getBasicEmployeeByCode();
                if (this.messageHideVariableBasic == false) {
                  this.toastr.success("Saved Successfully");
                }

                if (this.isProfile) {
                  //this.GetProfileVerificationStatus();
                }
                let currentUrl = window.location.pathname;
                if (
                  this.empCode != null &&
                  currentUrl != "/myprofile/" + this.empCode &&
                  currentUrl != "/hremployeedetails/" + this.empCode
                ) {
                  this.router.navigateByUrl(
                    "/hremployeedetails/" + this.empCode
                  );
                }
                this.hrBasicDetailsComponent.getCommunicationData();
                this.hrEmpCommunicationDetailsComponent.getCommunicationData();
                this.hrBasicDetailsComponent.getBasicEmployeeDetailsByCode(
                  this.empCode
                );
                this.loader = false;
                // this.hrBasicDetailsComponent.getRefreshPage()
                //to enable the tabs which are disabled incase of new employee
                this.disableTabs = false;
                //if value is true then it is moved to next tab
                if (value) {
                  this.changeTab();
                }
              },
              (error) => this.toastr.warning(error)
            );
          }
        } else {
          this.checkProfileSubmitBasic = true;
          this.HrEmpDtls = {
            ...this.HrEmpDtls,
            isFromProfile: this.isProfile,
          };
          this.emp_Svc.SaveHrEmployeeDetails(this.HrEmpDtls).subscribe(
            (data: any) => {
              // console.log("=========this.HrEmpDtls======", this.HrEmpDtls, this.HrEmpDtls.employeeDetails)
              if (!isNullOrUndefined(data.ErrorMsg)) {
                //Incase of new employee creation the created employee code is returned from api.
                //returned empcode in data is assigned to empCode to use for the remaining tabs
                this.empCode = data.ErrorMsg;
              }
              //this.hrBasicDetailsComponent.getCommunicationData();
              //this.hrEmpCommunicationDetailsComponent.getCommunicationData();
             // this.toggleBasicDetailsComponent();
              if (this.messageHideVariableBasic == false) {
                this.toastr.success("Saved Successfully");
              }

              if (this.isProfile) {
                //this.GetProfileVerificationStatus();
              }
              let currentUrl = window.location.pathname;
              if (
                this.empCode != null &&
                currentUrl != "/myprofile/" + this.empCode &&
                currentUrl != "/hremployeedetails/" + this.empCode
              ) {
                this.router.navigateByUrl("/hremployeedetails/" + this.empCode);
              }
              this.hrBasicDetailsComponent.getCommunicationData();
              this.hrEmpCommunicationDetailsComponent.getCommunicationData();
              this.hrBasicDetailsComponent.getBasicEmployeeDetailsByCode(
                this.empCode
              );
              this.cdr.detectChanges();
              this.loader = false;
              this.cdr.detectChanges();
              // this.hrBasicDetailsComponent.getRefreshPage()
              //to enable the tabs which are disabled incase of new employee
              this.disableTabs = false;
              //if value is true then it is moved to next tab
              if (value) {
                this.changeTab();
              }
            },
            (error) => this.toastr.warning(error)
          );
        }
      }
    }
    if (this.HrEmpDtls.Type === "Re-hire") {
      if (this.HrEmpDtls.GroupId != null) {
        this.getDetailsByGroupID(this.HrEmpDtls.GroupId)
          .then((data) => {
            if (data.result) {
              this.toastr.warning(
                "DOJ should be after the earlier Date of exit " +
                  formatDate(new Date(data.emp), "dd-MMM-yyyy", "en_US")
              );
              this.loader = false;
              return;
            } else {
              this.checkProfileSubmitBasic = true;
              this.HrEmpDtls = {
                ...this.HrEmpDtls,
                isFromProfile: this.isProfile,
              };
              this.emp_Svc.SaveHrEmployeeDetails(this.HrEmpDtls).subscribe(
                (data: any) => {
                  // console.log("=========this.HrEmpDtls======", this.HrEmpDtls, this.HrEmpDtls.employeeDetails)
                  if (!isNullOrUndefined(data.ErrorMsg)) {
                    this.empCode = data.ErrorMsg;
                  }
                 // this.toggleBasicDetailsComponent();
                  if (this.messageHideVariableBasic == false) {
                    this.toastr.success("Saved Successfully");
                    this.cdr.detectChanges();
                  }

                  if (this.isProfile) {
                    //this.GetProfileVerificationStatus();
                  }
                  let currentUrl = window.location.pathname;
                  if (
                    this.empCode != null &&
                    currentUrl != "/myprofile/" + this.empCode &&
                    currentUrl != "/hremployeedetails/" + this.empCode
                  ) {
                    this.router.navigateByUrl(
                      "/hremployeedetails/" + this.empCode
                    );
                  }
                  this.hrBasicDetailsComponent.getCommunicationData();
                  this.hrEmpCommunicationDetailsComponent.getCommunicationData();
                  this.hrBasicDetailsComponent.getBasicEmployeeDetailsByCode(
                    this.empCode
                  );
                  this.cdr.detectChanges();
                  this.loader = false;
                  this.cdr.detectChanges();
                  // this.hrBasicDetailsComponent.getRefreshPage()
                  //to enable the tabs which are disabled incase of new employee
                  this.disableTabs = false;
                  //if value is true then it is moved to next tab
                  if (value) {
                    this.changeTab();
                  }
                },
                (error) => this.toastr.warning(error)
              );
            }
          })
          .catch((error) => {
            this.error = error;
          });
      } else {
        this.HrEmpDtls = {
          ...this.HrEmpDtls,
          isFromProfile: this.isProfile,
        };
        this.emp_Svc.SaveHrEmployeeDetails(this.HrEmpDtls).subscribe(
          (data: any) => {
            // console.log("=========this.HrEmpDtls======", this.HrEmpDtls, this.HrEmpDtls.employeeDetails)
            if (!isNullOrUndefined(data.ErrorMsg)) {
              this.empCode = data.ErrorMsg;
            }
            //this.toggleBasicDetailsComponent();
            if (this.messageHideVariableBasic == false) {
              this.toastr.success("Saved Successfully");
              this.cdr.detectChanges();
            }

            if (this.isProfile) {
              //this.GetProfileVerificationStatus();
            }
            let currentUrl = window.location.pathname;
            if (
              this.empCode != null &&
              currentUrl != "/myprofile/" + this.empCode &&
              currentUrl != "/hremployeedetails/" + this.empCode
            ) {
              this.router.navigateByUrl("/hremployeedetails/" + this.empCode);
            }
            this.hrBasicDetailsComponent.getCommunicationData();
            this.hrEmpCommunicationDetailsComponent.getCommunicationData();
            this.hrBasicDetailsComponent.getBasicEmployeeDetailsByCode(
              this.empCode
            );
            this.cdr.detectChanges();
            this.loader = false;
            this.cdr.detectChanges();
            // this.hrBasicDetailsComponent.getRefreshPage()
            //to enable the tabs which are disabled incase of new employee
            this.disableTabs = false;
            //if value is true then it is moved to next tab
            if (value) {
              this.changeTab();
            }
          },
          (error) => this.toastr.warning(error)
        );
      }
    } else {
      this.HrEmpDtls = {
        ...this.HrEmpDtls,
        isFromProfile: this.isProfile,
      };
      this.emp_Svc.SaveHrEmployeeDetails(this.HrEmpDtls).subscribe(
        (data: any) => {
          // console.log("=========this.HrEmpDtls======", this.HrEmpDtls, this.HrEmpDtls.employeeDetails)
          if (!isNullOrUndefined(data.ErrorMsg)) {
            this.empCode = data.ErrorMsg;
          }
          //this.toggleBasicDetailsComponent();
          if (this.messageHideVariableBasic == false) {
            this.toastr.success("Saved Successfully");
            this.cdr.detectChanges();
          }

          if (this.isProfile) {
           // this.GetProfileVerificationStatus();
          }
          let currentUrl = window.location.pathname;
          if (
            this.empCode != null &&
            currentUrl != "/myprofile/" + this.empCode &&
            currentUrl != "/hremployeedetails/" + this.empCode
          ) {
            this.router.navigateByUrl("/hremployeedetails/" + this.empCode);
          }
          this.hrBasicDetailsComponent.getCommunicationData();
          this.hrEmpCommunicationDetailsComponent.getCommunicationData();
          this.hrBasicDetailsComponent.getBasicEmployeeDetailsByCode(
            this.empCode
          );
          this.cdr.detectChanges();
          this.loader = false;
          this.cdr.detectChanges();
          // this.hrBasicDetailsComponent.getRefreshPage()
          //to enable the tabs which are disabled incase of new employee
          this.disableTabs = false;
          //if value is true then it is moved to next tab
          if (value) {
            this.changeTab();
          }
        },
        (error) => this.toastr.warning(error)
      );
    }
  }

  getInvalidControls(formGroup: FormGroup): { [key: string]: any } {
    let invalidControls: { [key: string]: any } = {};

    for (const key in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(key)) {
        const control = formGroup.controls[key];
        if (control instanceof FormGroup) {
          const nestedInvalidControls = this.getInvalidControls(control);
          if (Object.keys(nestedInvalidControls).length > 0) {
            invalidControls[key] = nestedInvalidControls;
          }
        } else if (control instanceof FormControl && control.invalid) {
          invalidControls[key] = control.errors;
        }
      }
    }

    return invalidControls;
  }

  SavePersonalEmpDetails(value) {
    this.loader = true;
    window.scrollTo(0, 0);
    if (
      this.personalDetails.NoOfDependents != null &&
      this.personalDetails.NoOfDependents.toString() == ""
    ) {
      this.Children.clear();
    }
    this.personalDetailsComponent.PersonalDetform.markAllAsTouched();
    var result = this.personalDetailsComponent.getBasicEmployeeByCode();
    var team = this.personalDetailsComponent.getTeamValue(result.TeamId);
    this.personalDetails.EmpCode = this.empCode;
    this.datePipe = new DatePipe("en-US");
    //const controls = this.personalDetailsComponent.PersonalDetform.controls;

    //for (const controlName in controls) {
    //  if (controls[controlName].invalid) {
    //    console.log(`${controlName} is invalid`);
    //  }
    //}
    if (this.personalDetailsComponent.PersonalDetform.invalid) {
      this.toastr.warning("Please fill the required fields");
      this.loader = false;
      this.messageHideVariable = false;
      return;
    }
    //if (this.personalDetails.emergencyContactDtls.length < 1) {
    //  this.toastr.warning("Please fill the emergency contact details");
    //  this.loader = false;
    //  this.messageHideVariable = false;
    //  return;
    //}
    for (var i = 0; i < this.personalDetails.emergencyContactDtls.length; i++) {
      let element = this.personalDetails.emergencyContactDtls[i];
      if (
        element.ContactPhoneNumber &&
        element.ContactPhoneNumber.length !== 10
      ) {
        this.toastr.warning("Please enter a valid 10-digit Phone Number");
        this.loader = false;
        return;
      }
    }
    for (var i = 0; i < this.personalDetails.emergencyContactDtls.length; i++) {
      let element = this.personalDetails.emergencyContactDtls[i];
      if (
        element.ContactPhoneNumber != null &&
        element.ContactPhoneNumber != "" &&
        element.ContactPhoneNumber == result.MobileNo &&
        element.ContactPersonName != null &&
        element.ContactPersonName != ""
      ) {
        this.toastr.warning(
          "This Mobile# cannot be same as your Mobile# for " +
            element.ContactPersonName
        );
        this.loader = false;
        this.messageHideVariable = false;
        return;
      }
      if (
        element.ContactPhoneNumber != null &&
        element.ContactPhoneNumber != "" &&
        element.ContactPhoneNumber == result.MobileNo
      ) {
        this.toastr.warning("This Mobile# cannot be same as your Mobile#");
        this.loader = false;
        this.messageHideVariable = false;
        return;
      }
      if (
        team != null &&
        team == "Offshore" &&
        (isNullOrUndefined(element.ContactPersonName) ||
          element.ContactPersonName == "") &&
        (isNullOrUndefined(element.ContactPhoneNumber) ||
          element.ContactPhoneNumber == "") &&
        isNullOrUndefined(element.RelationId)
      ) {
        this.toastr.warning("Please fill the emergency contact details");
        this.loader = false;
        this.messageHideVariable = false;
        return;
      }

      if (
        team != null &&
        team == "Offshore" &&
        this.personalDetails.emergencyContactDtls[i].ContactPersonName !=
          null &&
        this.personalDetails.emergencyContactDtls[i].ContactPersonName != ""
      ) {
        if (
          this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber ==
            null ||
          this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber ==
            "" ||
          isNullOrUndefined(
            this.personalDetails.emergencyContactDtls[i].RelationId
          )
        ) {
          this.toastr.warning(
            "Please fill the remaining fields in emergency contact details"
          );
          this.loader = false;
          this.messageHideVariable = false;
          return;
        }
      } else {
        if (
          team != null &&
          team == "Offshore" &&
          (this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber !=
            null ||
            !isNullOrUndefined(
              this.personalDetails.emergencyContactDtls[i].RelationId
            ))
        ) {
          this.toastr.warning(
            "Please enter the name in emergency contact details"
          );
          this.messageHideVariable = false;
          this.loader = false;
          return;
        }
      }
      this.personalDetails.emergencyContactDtls[i].EmpCode = this.empCode;
      this.personalDetails.emergencyContactDtls[i].ModifiedBy =
        this.LoginEmpCode;
    }
    this.personalDetails.parentalLeaves =
      this.personalDetails.parentalLeaves.filter((element) => {
        return !(
          element.FromDate == null &&
          element.ToDate == null &&
          (element.Comments == null || element.Comments == "")
        );
      });
    var hasErrors = false;

    for (var i = 0; i < this.personalDetails.parentalLeaves.length; i++) {
      let element = this.personalDetails.parentalLeaves[i];

      element.FromDate = element.FromDate
        ? new Date(
            this.datePipe.transform(element.FromDate, this.config.dateFormat())
          )
        : element.FromDate;
      element.ToDate = element.ToDate
        ? new Date(
            this.datePipe.transform(element.ToDate, this.config.dateFormat())
          )
        : element.ToDate;

      if (
        (!isNullOrUndefined(element.FromDate) &&
          (isNullOrUndefined(element.ToDate) ||
            isNullOrUndefined(element.LeaveTypeId) ||
            element.LeaveTypeId == 0 ||
            (element.Comments && element.Comments.trim() == ""))) ||
        (!isNullOrUndefined(element.ToDate) &&
          (isNullOrUndefined(element.FromDate) ||
            (element.Comments && element.Comments.trim() == ""))) ||
        (element.Comments &&
          element.Comments.trim() != "" &&
          (isNullOrUndefined(element.FromDate) ||
            isNullOrUndefined(element.ToDate))) ||
        (element.FromDate &&
          element.ToDate &&
          element.FromDate.getTime() > element.ToDate.getTime())
      ) {
        this.toastr.warning(
          "Please fill the remaining fields in maternity/paternity"
        );
        this.loader = false;
        hasErrors = true;
        break;
      }

      if (
        !hasErrors &&
        this.personalDetails.parentalLeaves[i].FromDate &&
        this.personalDetails.parentalLeaves.some(
          (leave, indx) =>
            new Date(leave.FromDate).getTime() === element.FromDate.getTime() &&
            i !== indx
        )
      ) {
        this.toastr.warning("Select valid From date");
        this.loader = false;
        hasErrors = true;
        break;
      }

      if (
        !hasErrors &&
        this.personalDetails.parentalLeaves[i].ToDate &&
        this.personalDetails.parentalLeaves.some(
          (leave, indx) =>
            new Date(leave.ToDate).getTime() === element.ToDate.getTime() &&
            i !== indx
        )
      ) {
        this.toastr.warning("Select valid To date");
        this.loader = false;
        hasErrors = true;
        break;
      }

      // Check for overlapping date ranges
      if (element.FromDate && element.ToDate) {
        for (let j = 0; j < this.personalDetails.parentalLeaves.length; j++) {
          if (i !== j) {
            let otherLeave = this.personalDetails.parentalLeaves[j];
            if (
              !hasErrors &&
              new Date(element.FromDate).getTime() >
                new Date(otherLeave.FromDate).getTime() &&
              new Date(element.FromDate).getTime() <
                new Date(otherLeave.ToDate).getTime()
            ) {
              this.toastr.warning("Select valid From & To dates");
              this.loader = false;
              hasErrors = true;
              break;
            }
            if (
              !hasErrors &&
              new Date(element.FromDate).getTime() <
                new Date(otherLeave.FromDate).getTime() &&
              new Date(element.ToDate).getTime() >
                new Date(otherLeave.FromDate).getTime()
            ) {
              this.toastr.warning("Select valid From & To dates");
              this.loader = false;
              hasErrors = true;
              break;
            }
          }
        }
      }
      element.EmpCode = this.empCode;
      element.ModifiedBy = this.LoginEmpCode;
    }

    if (hasErrors) {
      this.loader = false;
      return;
    }

    //Assigned father,mother,spouse and children details are moved to array of FamilyDetails
    //Assigned father,mother,spouse and children details are moved to array of FamilyDetails
    this.personalDetails.FamilyDetails = [];
    this.personalDetails.Father.RelationId = 1; // RelationId 1 indicates father
    this.personalDetails.FamilyDetails[0] = this.personalDetails.Father;
    this.personalDetails.Mother.RelationId = 2; // RelationId 2 indicates mother
    this.personalDetails.FamilyDetails[1] = this.personalDetails.Mother;
    if (this.personalDetails.MaritalStatus == 1) {
      //MaritalStatus 1 indicates Married
      //If wedding date has value then changes the date format
      if (!isNullOrUndefined(this.personalDetails.WeddingDate))
        this.personalDetails.WeddingDate = new Date(
          this.datePipe.transform(
            this.personalDetails.WeddingDate,
            this.config.dateFormat()
          )
        );
      this.personalDetails.Spouse.RelationId = 3; // RelationId 3 indicates spouse
      this.personalDetails.FamilyDetails[2] = this.personalDetails.Spouse;
    }
    if (this.personalDetails.MaritalStatus) {
      if (this.personalDetails.MaritalStatus == 1) {
        var j = 3;
      } else {
        var j = 2;
      }
      for (var i = 0; i < this.Children.value.length; i++) {
        this.personalDetails.FamilyDetails[j] = this.Children.value[i];
        j += 1;
      }
    }
    for (var i = 0; i < this.Children.value.length; i++) {
      var child = this.Children.value[i];
      if (child.Name == "" || child.RelationId == "" || child.DOB == "") {
        this.toastr.warning("Please fill the required fields");
        this.loader = false;
        return;
      }
    }
    for (var i = 0; i < this.personalDetails.FamilyDetails.length; i++) {
      this.personalDetails.FamilyDetails[i].EmpCode = this.empCode;
      this.personalDetails.FamilyDetails[i].ModifiedBy = this.LoginEmpCode;
      if (!isNullOrUndefined(this.personalDetails.FamilyDetails[i].DOB))
        this.personalDetails.FamilyDetails[i].DOB = new Date(
          this.datePipe.transform(
            this.personalDetails.FamilyDetails[i].DOB,
            this.config.dateFormat()
          )
        );
    }
    if (value == true) {
      this.SaveVerificationDetails(this.selectedIndex + 1);
      this.personalDetails.profileVerification = this.Verify;
    } else {
      this.personalDetails.profileVerification = this.Verify;
    }
    if (this.messageHideVariable == true) {
      if (value == false) {
        this.SaveVerificationDetails(2);
        this.personalDetails.profileVerification = this.Verify;
        // this.personalDetails.profileVerification.Submitted = true;
        // this.personalDetails.twoTabProfile = true;
      } else {
        this.personalDetails.profileVerification = null;
      }
    }
    this.checkProfileSubmitPersonal = true;
    this.emp_Svc.SaveEmpPersonalDetails(this.personalDetails).subscribe(
      (data: any) => {
        if (this.messageHideVariable == false) {
          this.toastr.success("Saved Successfully");
        }
        if (this.isProfile) {
          //this.GetProfileVerificationStatus();
        }
        this.loader = false;
        // this.personalDetailsComponent.getRefreshPage()
        // this.hrEmpCommunicationDetailsComponent.getRefreshPage()
        //this.togglePersonalDetailsComponent();
        //if value is true then it is moved to next tab
        //this.hrEmpCommunicationDetailsComponent.getCommunicationData();
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  SaveVerificationDetails(tabId) {
    this.Verify = new ProfileVerificationStatus();
    this.Verify.SectionId = tabId;
    this.Verify.EmpCode = this.LoginEmpCode;
    this.Verify.Status = true;
    this.Verify.Submitted = null;
  }

  async SavePassportVisaDetails(value) {
    this.loader = true;
    window.scrollTo(0, 0);
    this.datePipe = new DatePipe("en-US");
    if (this.passportArray.value.length != 0) {
      for (var j = 0; j < this.passportArray.value.length; j++) {
        var element = this.passportArray.value[j];
        if (
          (element.DocNumber == null || element.DocNumber == "") &&
          element.IssueDate == null &&
          element.ExpiryDate == null &&
          element.Country == "" &&
          element.File == ""
        ) {
          this.passportArray.value.splice(j, 1);
          j--;
        }
      }
      if (this.passportArray.value.length != 0) {
        const passportDetails = this.passportArray;
        await Promise.all(
          passportDetails.value.map(async (details) => {
            if (
              details.File != null &&
              details.File.files &&
              details.File.files.length > 0
            ) {
              const chequeFile = details.File.files[0];
              details.File = await this.file_Svc.convertFileToFileToUpload(
                chequeFile
              );
              this.passportArray = passportDetails;
            }
          })
        );
      }
      for (var k = 0; k < this.passportArray.value.length; k++) {
        var count = 0;
        for (var l = 0; l < this.passportArray.value.length; l++) {
          var passport1 = this.passportArray.value[k];
          var passport2 = this.passportArray.value[l];
          if (passport1.ExpiryDate != null && passport2.ExpiryDate != null) {
            passport1.ExpiryDate = formatDate(
              passport1.ExpiryDate,
              "dd-MMM-yyyy",
              "en_US"
            );
            passport2.ExpiryDate = formatDate(
              passport2.ExpiryDate,
              "dd-MMM-yyyy",
              "en_US"
            );
          }
          if (
            !isNullOrUndefined(passport1.DocNumber) &&
            passport1.DocNumber != "" &&
            !isNullOrUndefined(passport2.DocNumber) &&
            passport2.DocNumber != "" &&
            passport1.ExpiryDate != null &&
            passport2.ExpiryDate != null &&
            passport1.DocNumber == passport2.DocNumber &&
            passport1.ExpiryDate == passport2.ExpiryDate
          ) {
            count++;
          }
        }
      }
      if (count > 1) {
        this.toastr.warning(
          "Passport number and Expiry date must be unique in passport information"
        );
        this.loader = false;
        return;
      }
      for (var i = 0; i < this.passportArray.value.length; i++) {
        this.passportArray.value[i].EmpCode = this.empCode;
        if (
          !isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
          this.passportArray.value[i].DocNumber != "" &&
          this.passportArray.value[i].DocNumber.length < 4
        ) {
          this.toastr.warning("Enter valid passport number");
          this.loader = false;
          return;
        }
        if (this.passportArray.value[i].IssueDate != null)
          this.passportArray.value[i].IssueDate = new Date(
            this.datePipe.transform(
              this.passportArray.value[i].IssueDate,
              this.config.dateFormat()
            )
          );
        if (this.passportArray.value[i].ExpiryDate != null)
          this.passportArray.value[i].ExpiryDate = new Date(
            this.datePipe.transform(
              this.passportArray.value[i].ExpiryDate,
              this.config.dateFormat()
            )
          );
        this.passportArray.value[i].ModifiedBy = this.LoginEmpCode;
        if (
          !isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
          !isNullOrUndefined(this.passportArray.value[i].IssueDate) &&
          !isNullOrUndefined(this.passportArray.value[i].ExpiryDate)
        ) {
          if (
            this.passportArray.value[i].IssueDate >=
            this.passportArray.value[i].ExpiryDate
          ) {
            this.toastr.warning(
              "Passport Issue Date should not be greater than or equal to Expiry Date"
            );
            this.loader = false;
            return;
          }
        }
        if (
          !isNullOrUndefined(this.passportArray.value[i].File) &&
          this.passportArray.value[i].File != ""
        ) {
          if (
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the details to save the passport file"
            );
            this.loader = false;
            return;
          }
        }
        if (
          !isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
          this.passportArray.value[i].DocNumber != ""
        ) {
          if (
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            this.loader = false;
            return;
          }
        } else if (!isNullOrUndefined(this.passportArray.value[i].IssueDate)) {
          if (
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            this.passportArray.value[i].DocNumber == "" ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            this.loader = false;
            return;
          }
        } else if (!isNullOrUndefined(this.passportArray.value[i].ExpiryDate)) {
          if (
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            this.passportArray.value[i].DocNumber == "" ||
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            this.loader = false;
            return;
          }
        } else if (
          !isNullOrUndefined(this.passportArray.value[i].Country) &&
          this.passportArray.value[i].Country != ""
        ) {
          if (
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            this.passportArray.value[i].DocNumber == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            this.loader = false;
            return;
          }
        }
        if (
          this.passportArray.value[i].ID <= 0 &&
          (isNullOrUndefined(this.passportArray.value[i].File) ||
            this.passportArray.value[i].File == "")
        ) {
          if (
            (!isNullOrUndefined(this.passportArray.value[i].Country) &&
              this.passportArray.value[i].Country != "") ||
            !isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            !isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            (!isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
              this.passportArray.value[i].DocNumber != "")
          ) {
            this.toastr.warning(
              "Please select document to save the remaining details for your passport"
            );
            this.loader = false;
            return;
          }
        }
      }
    }
    if (this.visaArray.value.length != 0) {
      const visaDetails = this.visaArray;
      await Promise.all(
        visaDetails.value.map(async (details) => {
          if (
            details.File != null &&
            details.File.files &&
            details.File.files.length > 0
          ) {
            const chequeFile = details.File.files[0];
            details.File = await this.file_Svc.convertFileToFileToUpload(
              chequeFile
            );
            this.visaArray = visaDetails;
          }
        })
      );
      for (var i = 0; i < this.visaArray.value.length; i++) {
        this.visaArray.value[i].Country =
          this.visaArray.value[i].Country == "Other"
            ? this.visaArray.value[i].CountryName
            : this.visaArray.value[i].Country;
        this.visaArray.value[i].EmpCode = this.empCode;
        this.visaArray.value[i].Validity = new Date(
          this.datePipe.transform(
            this.visaArray.value[i].Validity,
            this.config.dateFormat()
          )
        );
        this.visaArray.value[i].ModifiedBy = this.LoginEmpCode;
        if (!isNullOrUndefined(this.visaArray.value[i].ExpiryDate))
          this.visaArray.value[i].ExpiryDate = new Date(
            this.datePipe.transform(
              this.visaArray.value[i].ExpiryDate,
              this.config.dateFormat()
            )
          );
        if (
          !isNullOrUndefined(this.visaArray.value[i].File) &&
          this.visaArray.value[i].File != ""
        ) {
          if (
            this.visaArray.value[i].Country === "" ||
            (this.visaArray.value[i].Country === "Other" &&
              this.visaArray.value[i].CountryName === "") ||
            this.visaArray.value[i].DocType === "" ||
            isNullOrUndefined(this.visaArray.value[i].ExpiryDate)
          ) {
            this.toastr.warning(
              "Please fill the details to save the visa file"
            );
            this.loader = false;
            return;
          }
        } else if (
          this.visaArray.value[i].Country != "" ||
          (this.visaArray.value[i].Country === "Other" &&
            this.visaArray.value[i].CountryName === "")
        ) {
          if (
            this.visaArray.value[i].DocType === "" ||
            isNullOrUndefined(this.visaArray.value[i].ExpiryDate)
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your visa information"
            );
            this.loader = false;
            return;
          }
        } else if (this.visaArray.value[i].DocType != "") {
          if (
            this.visaArray.value[i].Country === "" ||
            isNullOrUndefined(this.visaArray.value[i].ExpiryDate)
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your visa information"
            );
            this.loader = false;
            return;
          }
        } else if (!isNullOrUndefined(this.visaArray.value[i].ExpiryDate)) {
          if (
            this.visaArray.value[i].DocType === "" ||
            this.visaArray.value[i].Country === ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your visa information"
            );
            this.loader = false;
            return;
          }
        }
        if (
          this.visaArray.value[i].ExpiryDate &&
          this.visaArray.value[i].DocType != "" &&
          this.visaArray.value[i].Country != "" &&
          (isNullOrUndefined(this.visaArray.value[i].File) ||
            this.visaArray.value[i].File === "")
        ) {
          if (isNullOrUndefined(this.visaArray.value[i].DocumentPath)) {
            this.toastr.warning("Please attach the visa file");
            this.loader = false;
            return;
          }
        }
      }
    }
    this.passportVisaDetails.passportDtls = this.passportArray.value;
    this.passportVisaDetails.VisaDtls = this.visaArray.value;
    if (value == true) {
      this.SaveVerificationDetails(this.selectedIndex + 1);
      this.passportVisaDetails.profileVerification = this.Verify;
    } else {
      this.passportVisaDetails.profileVerification = null;
    }

    this.emp_Svc.SavePassportVisaDetails(this.passportVisaDetails).subscribe(
      (data: any) => {
        this.passportvisaInformationComponent.GetHREmpPassportVisaInfo();
        this.toastr.success("Saved Successfully");
        this.loader = false;
        //this.togglePassportDetailsComponent();
        //if value is true then it is moved to next tab
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  async SaveFinanceDetails(value) {
    this.loader = true;
    this.financeDetailsComponent.FinanceForm.markAllAsTouched();
    window.scrollTo(0, 0);
    if (
      this.FinanceDetails.NoOfAccounts == null ||
      this.FinanceDetails.NoOfAccounts == 0
    ) {
      this.toastr.warning("No. of bank accounts should be atleast one");
      this.loader = false;
      return;
    }
    this.FinanceDetails.empFinanceDetails =
      this.financeDetailsComponent.GetFinanceDetails();
    const financeDetails = this.financeDetailsComponent.GetFinanceDetails();
    await Promise.all(
      financeDetails.map(async (details) => {
        if (
          details.CancelledChequeFile &&
          details.CancelledChequeFile.files &&
          details.CancelledChequeFile.files.length > 0
        ) {
          const chequeFile = details.CancelledChequeFile.files[0];
          details.CancelledChequeFile =
            await this.file_Svc.convertFileToFileToUpload(chequeFile);
          this.FinanceDetails.empFinanceDetails = financeDetails;
        }
      })
    );
    this.FinanceDetails.ModifiedBy = this.LoginEmpCode;
    for (var i = 0; i < this.FinanceDetails.empFinanceDetails.length; i++) {
      let element = this.FinanceDetails.empFinanceDetails[i];
      element.EmpCode = this.empCode;
      element.CreatedBy =
        element.Id > 0 ? element.CreatedBy : this.empCode.toString();
      element.ModifiedBy = this.LoginEmpCode;
      if (
        isNullOrUndefined(element.BankAccount) ||
        element.BankAccount == "" ||
        isNullOrUndefined(element.IFSCCode) ||
        element.IFSCCode == "" ||
        isNullOrUndefined(element.BankAccountName) ||
        element.BankAccountName == "" ||
        isNullOrUndefined(element.BankName) ||
        element.BankName == "" ||
        isNullOrUndefined(element.Branch) ||
        element.Branch == "" ||
        ((isNullOrUndefined(element.CancelledChequeFile) ||
          element.CancelledChequeFile.fileName == "") &&
          isNullOrUndefined(element.CancelledChequeFilePath))
      ) {
        this.toastr.warning("Please fill all the details in Bank Accounts");
        this.loader = false;
        return;
      } else if (
        !isNullOrUndefined(element.BankAccount) &&
        element.BankAccount != ""
      ) {
        if (
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        !isNullOrUndefined(element.IFSCCode) &&
        element.IFSCCode != ""
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        !isNullOrUndefined(element.BankAccountName) &&
        element.BankAccountName != ""
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        !isNullOrUndefined(element.BankName) &&
        element.BankName != ""
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (!isNullOrUndefined(element.Branch) && element.Branch != "") {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        (!isNullOrUndefined(element.CancelledChequeFile) &&
          element.CancelledChequeFile.fileName != "") ||
        !isNullOrUndefined(element.CancelledChequeFilePath)
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          (isNullOrUndefined(element.Branch) && element.Branch == "")
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      }
    }
    for (var k = 0; k < this.FinanceDetails.empFinanceDetails.length; k++) {
      var count = 0;
      for (var l = 0; l < this.FinanceDetails.empFinanceDetails.length; l++) {
        var finance1 = this.FinanceDetails.empFinanceDetails[k];
        var finance2 = this.FinanceDetails.empFinanceDetails[l];
        if (
          !isNullOrUndefined(finance1.BankAccount) &&
          finance1.BankAccount != "" &&
          !isNullOrUndefined(finance2.BankAccount) &&
          finance2.BankAccount != "" &&
          !isNullOrUndefined(finance1.IFSCCode) &&
          finance1.IFSCCode != "" &&
          !isNullOrUndefined(finance2.IFSCCode) &&
          finance2.IFSCCode != "" &&
          finance1.BankAccount == finance2.BankAccount &&
          finance1.IFSCCode == finance2.IFSCCode
        ) {
          count++;
        }
      }
    }
    if (count > 1) {
      this.toastr.warning(
        "Bank Account# and IFSC Code must be unique in finance details"
      );
      this.loader = false;
      return;
    }
    if (this.financeDetailsComponent.FinanceForm.invalid) {
      this.toastr.warning("Please fill the require fields");
      this.loader = false;
      return;
    }
    let anyCheckboxChecked =
      this.FinanceDetails.empFinanceDetails.length > 0
        ? this.FinanceDetails.empFinanceDetails.some(
            (item) => item.BankAccount != "" && item.Primary
          )
        : false;
    if (!anyCheckboxChecked) {
      this.toastr.warning("Please select the primary bank account");
      this.loader = false;
      return;
    }
    if (value == true) {
      this.SaveVerificationDetails(this.selectedIndex + 1);
      this.FinanceDetails.profileVerification = this.Verify;
    } else {
      this.FinanceDetails.profileVerification = null;
    }
    this.FinanceDetails = {
      ...this.FinanceDetails,
      isFromProfile: this.isProfile,
    };
    this.emp_Svc.SaveFinanceDetails(this.FinanceDetails).subscribe(
      (data: any) => {
        this.financeDetailsComponent.GetHrEmpolyeeFinanceDetails();
        this.toastr.success("Saved Successfully");
        this.loader = false;
        //this.toggleFinancialDetailsComponent();
        //if value is true then it is moved to next tab
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  SaveEmployeeAwards(value) {
    this.loader = true;
    window.scrollTo(0, 0);
    this.award = this.hrAwardsComponent.getAwards();
    if (this.hrAwardsComponent.AwardForm.invalid) {
      this.toastr.warning("Please fill the required fields");
      this.loader = false;
      return;
    }
    this.datePipe = new DatePipe("en-US");
    if (!isNullOrUndefined(this.award.Date)) {
      this.award.Date = new Date(
        this.datePipe.transform(this.award.Date, this.config.dateFormat())
      );
    }
    this.award.EmpCode = this.empCode;
    this.award.ModifiedBy = this.LoginEmpCode;

    //this.awardDetails[i].NominatedBy =
    var id = this.hrAwardsComponent.NominatedBy.split("-");
    var idlength = id.length - 1;
    this.award.NominatedBy = id[idlength];

    this.emp_Svc.SaveEmployeeAwards(this.award).subscribe(
      (data: any) => {
        if (data.ErrorType == "Exception") {
          this.toastr.warning(data.ErrorMsg);
        } else {
          this.toastr.success("Saved Successfully");
          this.loader = false;
          //this.toggleAwardsDetailsComponent();
          this.GetEmployeeAwardDetails();
          this.hrAwardsComponent.loadFinancialYears();
        }
        //if value is true then it is moved to next tab
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );

    //  this.GetEmployeeAwardDetails();
  }

  SaveHiringDetails(value) {
    this.loader = true;
    window.scrollTo(0, 0);
    this.hrHiringDetailsComponent.hrdetailsform.markAllAsTouched();
    this.hrHiringDetails = this.hrHiringDetailsComponent.getHiringDetails();

    if (this.hrHiringDetails != null) {
      const controls = this.hrHiringDetailsComponent.hrdetailsform.controls;

      //for (const controlName in controls) {
      //  if (controls[controlName].invalid) {
      //    console.log(`${controlName} is invalid`);
      //  }
      //}

      if (this.hrHiringDetailsComponent.hrdetailsform.invalid) {
        this.toastr.warning("Please fill the required fields");
        this.loader = false;
        return;
      }

      let finalDataRes;
      if (this.hrHiringDetails.employeeBonusDetailsList) {
        for (
          var i = 0;
          i < this.hrHiringDetails.employeeBonusDetailsList.length;
          i++
        ) {
          if (
            this.hrHiringDetails.employeeBonusDetailsList[i].EffectiveDate._d
          ) {
            const effectiveDate = moment.tz(
              this.hrHiringDetails.employeeBonusDetailsList[i].EffectiveDate._d,
              "Asia/Kolkata"
            );
            const formattedDate = effectiveDate.format(
              "YYYY-MM-DD hh:mm:ss.SSS"
            );
            this.hrHiringDetails.employeeBonusDetailsList[i].EffectiveDate =
              formattedDate;
          }
        }

        const finalData = this.hrHiringDetails.employeeBonusDetailsList;

        this.hrHiringDetails.orgEmployeeBonusDetailsList = [...finalData];
        const arr = [];
        const encryptedData = finalData.map((obj) => {
          Object.entries(obj).forEach(([key, value]) => {
            obj[key] =
              key === "RelocationEligibility"
                ? value
                : key === "EffectiveDate"
                ? value
                : key === "EmpCode"
                ? value
                : key === "OfferLetterDocumentName"
                ? value
                : key === "OfferLetterDocumentPath"
                ? value
                : key === "JoiningBonus"
                ? value
                : value
                ? this.encryptFun(value)
                : value;
          });
          if (!obj.JoiningBonus) {
            obj["JoiningBonus"] = "";
          }
          arr.push(obj);
          return obj;
        });
        finalDataRes = encryptedData.map(
          ({ orgEmployeeBonusDetailsList, ...rest }) => rest
        );
        this.hrHiringDetails.employeeBonusDetailsList = finalDataRes;
      }

      this.emp_Svc
        .SaveEmployeeHiringDetails({ ...this.hrHiringDetails })
        .subscribe(
          (data: any) => {
            if (data.ErrorType == "Exception") {
              this.toastr.warning(data.ErrorMsg);
            } else {
              this.toastr.success("Saved Successfully");
              this.loader = false;
              this.hrHiringDetailsComponent.getData();
             // this.toggleHiringDetailsComponent();
            }
            //if value is true then it is moved to next tab
            if (value) {
              this.changeTab();
            }
          },
          (error) => this.toastr.warning(error)
        );
    }
  }

  getEmpHistory() {
    this.emp_Svc.getEmployeeHistory(this.empCode).subscribe(
      (data: any) => {},
      (error) => this.toastr.warning(error)
    );
  }

  SaveEmployeeHistory(value) {
    this.hrHistoryComponent.GetHistory();
    var invalidError = false;
    this.loader = true;
    window.scrollTo(0, 0);
    this.datePipe = new DatePipe("en-US");

    const { isValid, errorMessages } = this.hrHistoryComponent.isValid();

    if (!isValid) {
      errorMessages.forEach((errorMessage) => {
        this.toastr.warning(errorMessage);
      });
      this.loader = false;
      return;
    }

    if (!isNullOrUndefined(this.HrEmp.peopleManagersHistoryDetails)) {
      this.HrEmp.peopleManagersHistoryDetails.forEach((obj) => {
        if (obj.InvalidName) {
          this.toastr.warning("Select valid value");
          invalidError = true;
          return;
        }
        if (!isNullOrUndefined(obj.DurationFrom)) {
          obj.DurationFrom = new Date(
            this.datePipe.transform(obj.DurationFrom, this.config.dateFormat())
          );
        }
        if (!isNullOrUndefined(obj.DurationTo)) {
          obj.DurationTo = new Date(
            this.datePipe.transform(obj.DurationTo, this.config.dateFormat())
          );
        }
        if (isNullOrUndefined(obj.CreatedBy)) {
          obj.CreatedBy = this.LoginEmpCode;
        }
        obj.EmpCode = this.HrEmpDtls.EmpCode;
      });
    }
    if (!isNullOrUndefined(this.HrEmp.seniorManagersHistoryDetails)) {
      this.HrEmp.seniorManagersHistoryDetails.forEach((obj) => {
        if (obj.InvalidName) {
          this.toastr.warning("Select valid value");
          invalidError = true;
          return;
        }
        if (!isNullOrUndefined(obj.DurationFrom)) {
          obj.DurationFrom = new Date(
            this.datePipe.transform(obj.DurationFrom, this.config.dateFormat())
          );
        }
        if (!isNullOrUndefined(obj.DurationTo)) {
          obj.DurationTo = new Date(
            this.datePipe.transform(obj.DurationTo, this.config.dateFormat())
          );
        }
        if (isNullOrUndefined(obj.CreatedBy)) {
          obj.CreatedBy = this.LoginEmpCode;
        }
        obj.EmpCode = this.HrEmpDtls.EmpCode;

        if (obj.smDisplayName == null) {
          // this.HrEmpDtls.seniorManagersHistoryDetails.pop();
        }
      });
    }

    if (!isNullOrUndefined(this.HrEmp.employeeDesignationHistories)) {
      this.HrEmp.employeeDesignationHistories.forEach((obj) => {
        if (!isNullOrUndefined(obj.StartDate)) {
          obj.StartDate = new Date(
            this.datePipe.transform(obj.StartDate, this.config.dateFormat())
          );
        }
        if (!isNullOrUndefined(obj.EndDate)) {
          obj.EndDate = new Date(
            this.datePipe.transform(obj.EndDate, this.config.dateFormat())
          );
        }
        if (isNullOrUndefined(obj.CreatedBy)) {
          obj.CreatedBy = this.LoginEmpCode;
        }
        obj.EmpCode = this.HrEmpDtls.EmpCode;
      });
    }

    if (!isNullOrUndefined(this.HrEmp.employeeLocationHistories)) {
      this.HrEmp.employeeLocationHistories.forEach((obj) => {
        if (!isNullOrUndefined(obj.StartDate)) {
          obj.StartDate = new Date(
            this.datePipe.transform(obj.StartDate, this.config.dateFormat())
          );
        }
        if (!isNullOrUndefined(obj.EndDate)) {
          obj.EndDate = new Date(
            this.datePipe.transform(obj.EndDate, this.config.dateFormat())
          );
        }
        if (isNullOrUndefined(obj.CreatedBy)) {
          obj.CreatedBy = this.LoginEmpCode;
        }
        obj.EmpCode = this.HrEmpDtls.EmpCode;
      });
    }

    if (!isNullOrUndefined(this.HrEmp.employeeDepartmentHistories)) {
      this.HrEmp.employeeDepartmentHistories.forEach((obj) => {
        if (!isNullOrUndefined(obj.StartDate)) {
          obj.StartDate = new Date(
            this.datePipe.transform(obj.StartDate, this.config.dateFormat())
          );
        }
        if (!isNullOrUndefined(obj.EndDate)) {
          obj.EndDate = new Date(
            this.datePipe.transform(obj.EndDate, this.config.dateFormat())
          );
        }
        if (isNullOrUndefined(obj.CreatedBy)) {
          obj.CreatedBy = this.LoginEmpCode;
        }
        obj.EmpCode = this.HrEmpDtls.EmpCode;
      });
    }

    if (!isNullOrUndefined(this.HrEmp.employeeCadreHistories)) {
      this.HrEmp.employeeCadreHistories.forEach((obj) => {
        if (!isNullOrUndefined(obj.StartDate)) {
          obj.StartDate = new Date(
            this.datePipe.transform(obj.StartDate, this.config.dateFormat())
          );
        }
        if (!isNullOrUndefined(obj.EndDate)) {
          obj.EndDate = new Date(
            this.datePipe.transform(obj.EndDate, this.config.dateFormat())
          );
        }
        if (isNullOrUndefined(obj.CreatedBy)) {
          obj.CreatedBy = this.LoginEmpCode;
        }
        obj.EmpCode = this.HrEmpDtls.EmpCode;
      });
    }
    if (invalidError) {
      return;
    }
    if (this.HrEmp.hasErrorss == true) {
      this.toastr.warning("Please fill the required fields");
    } else {
      var empHistoryDetails = new EmpHistoryDetails();
      empHistoryDetails.historyDetails = new HistoryDetails();
      empHistoryDetails.historyDetails = this.HrEmp;
      this.emp_Svc.SaveEmployeeHistory(empHistoryDetails).subscribe(
        (data: any) => {
          if (!isNullOrUndefined(data.ErrorMsg)) {
            this.empCode = data.ErrorMsg;
          }

          this.hrHistoryComponent.getEmployeeSMList();
          this.hrHistoryComponent.getEmployeeList();
          this.hrHistoryComponent.getEmpHistory();

          if (this.messageHideVariableBasic == false) {
            this.toastr.success("Saved Successfully");
            this.loader = false;
            //this.toggleHistoryDetailsComponent();
          }

          /* setTimeout(() => {*/

          /*  }, 800);*/
          //to enable the tabs which are disabled incase of new employee
          this.disableTabs = false;
          //if value is true then it is moved to next tab
          if (value) {
            this.changeTab();
          }
        },
        (error) => this.toastr.warning(error)
      );
    }
  }

  GetProfileVerificationStatus() {
    if (this.isProfile) {
      this.emp_Svc
        .GetProfileVerificationStatus(this.LoginEmpCode)
        .subscribe((data: any) => {
          this.profileverificationDetails = data;
          for (var i = 0; i < this.profileverificationDetails.length; i++) {
            if (this.profileverificationDetails[i].Name == "Employee Details") {
              this.profileverificationDetails[i].Name = "Basic Details";
            }
          }
          for (var i = 0; i < data.length; i++) {
            this.approveCheck = data[i].Submitted;
            //console.log(this.approveCheck, i)
            if (data.length == 6) {
              this.disableSave = true;
            }
          }
          if (this.approveCheck == true) this.disableCheckbox = true;
          var count = 0;
          this.profileverificationDetails.forEach((item) => {
            if (item.Status == true) {
              count += 1;
              //since tab index starts from 0 to compare with sections we add 1
              var sectionId = this.selectedIndex + 1;
            }
          });
          if (count == 6 && this.checkedVerified == true) {
            this.profileverificationDetails.forEach((item) => {
              item.Submitted = true;
            });
          }
          this.sendMail = this.profileverificationDetails;
        });
    }
  }

  decryptAES(encryptedData, privateKeyBase64: string) {
    try {
      let cipherPhrase = privateKeyBase64;

      var key = CryptoJS.enc.Utf8.parse(cipherPhrase);
      var iv = CryptoJS.enc.Utf8.parse("");

      if (encryptedData) {
        var decrypted = CryptoJS.AES.decrypt(encryptedData.trim(), key, {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });

        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      } else {
        return encryptedData;
      }
    } catch (e) {}
  }

  encryptFun(data) {
    data = data === undefined ? "" : data;
    data = data.toString();
    try {
      let cipherPhrase = this.privateKeyBase64;

      var key = CryptoJS.enc.Utf8.parse(cipherPhrase);
      var iv = CryptoJS.enc.Utf8.parse(""); // Empty IV as per your decryption code.

      if (data) {
        var encrypted = CryptoJS.AES.encrypt(data, key, {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });

        return encrypted.toString(); // Return as a base64 string
      } else {
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  }

  SubmitProfileStatus() {
    var msg = `Are you sure to submit the form?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.loader = true;
          window.scrollTo(0, 0);
          if (
            this.hrBasicDetailsComponent.EmpDetform.valid &&
            this.hrEmpCommunicationDetailsComponent.EmpAddform.valid &&
            this.personalDetailsComponent.PersonalDetform.valid &&
            this.personalDetails.emergencyContactDtls.length > 0
          ) {
            this.messageHideVariable = true;
            this.messageHideVariableBasic = true;
            this.SaveHrEmployeeDetails(false);

            this.SavePersonalEmpDetails(false);
            if (
              this.checkProfileSubmitBasic == true &&
              this.checkProfileSubmitPersonal == true
            ) {
              if (this.profileverificationDetails.length != 0) {
                this.profileverificationDetails[0].Submitted = true;
              }
              this.emp_Svc
                .SaveProfileVerificationStatus(this.profileverificationDetails)
                .subscribe(
                  (data: ProfileVerificationStatus[]) => {
                    this.toastr.success("Submitted Successfully");
                    this.loader = false;
                    location.reload();
                   // this.GetProfileVerificationStatus();
                  },
                  (error) => (this.error = error)
                );
            }
          } else {
            this.toastr.warning(
              "Please fill all the required fields in both sections"
            );
            this.messageHideVariable = false;
            this.loader = false;
            return;
          }
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }

  GetEmployeeAwardDetails() {
    this.award.EmpCode = this.empCode;
    this.awardDetails = [];
    this.emp_Svc.getEmployeeAwardDetails(this.empCode).subscribe(
      (data: any) => {
        if (data != null && data.length != 0) {
          this.awardDetails = data;
        } else {
          this.toastr.warning("No awards for the employee");
        }
      },
      (error) => (this.error = error)
    );
  }

  Cancel() {
    this.router.navigateByUrl(`/hremployeelist/${this.empCode}`);
  }

  getExitInterviewResponses() {
    this.emp_Svc
      .getExitInterviewHistory(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.ResponseList = data;

        if (
          this.ResponseList &&
          this.ResponseList.IsEmpFeedbackRequired &&
          !this.ResponseList.IsRejected
        ) {
          this.isAccordion = true;
        } else if (this.ResponseList && this.ResponseList.IsRejected) {
          this.isAccordion = false;
        } else {
          this.isAccordion = false;
        }
      });
  }
}
//Custom Validation for email
function emailDomain(control: AbstractControl): { [key: string]: any } | null {
  const emailId: string = control.value;
  const domain = emailId.substring(emailId.lastIndexOf("@") + 1);
  if (emailId === "" || domain.toLowerCase() === "winwire.com") {
    return null;
  } else {
    return { emailDomain: true };
  }
}

function formatToCustomDate(date: any): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}
